export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  // 404页面
  'pages.404.title': '404',
  // info页面
  'pages.info.title': '页面开发中',
  'pages.info.subTitle': '功能正在开发中，敬请期待...',
  'pages.info.buttonText': '返回首页',
  // Admin页面
  'pages.admin.addMorePages': 'Want to add more pages? Please refer to',
  'pages.admin.useBlock': 'use block',
  // Login页面（补充）
  'pages.login.title': '欢迎登录',
  'pages.login.subtitle': '没有账号？',
  'pages.login.getStarted': '联系管理员',
  'pages.login.needHelp': '需要帮助？',
  'pages.login.welcome': '安盾智眼',
  'pages.login.welcomeSubtitle': '聚焦用电安全与电气火灾风险监控，持续守护配电终端、线路与关键负载。',
  'pages.login.moltenSaltInfo': '本平台面向用电安全监测场景，支持电气火灾风险识别、隐患预警和终端运行状态持续跟踪。',
  'pages.login.username.label': '用户名',
  'pages.login.password.label': '密码',
  // Workplace页面
  'pages.workplace.title': '工作台',
  'pages.workplace.description': '实时监控各类任务状态，快速创建数据导入任务',
  'pages.workplace.dataImportApproval': '数据导入审批',
  'pages.workplace.dataProcessingPipeline': '数据处理流水线',
  'pages.workplace.workflowTask': '工作流任务',
  'pages.workplace.dataUploadTask': '数据上传任务',
  'pages.workplace.anomalyDetectionTask': '异常检测任务',
  'pages.workplace.performancePredictionTask': '性能预测任务',
  'pages.workplace.modelTrainingTask': '模型训练任务',
  'pages.workplace.modelTestingTask': '模型测试任务',
  'pages.workplace.quickCreate': '快捷创建',
  'pages.workplace.status.pending': '待审批',
  'pages.workplace.status.approving': '审批中',
  'pages.workplace.status.completed': '已完成',
  'pages.workplace.status.queued': '排队中',
  'pages.workplace.status.running': '运行中',
  'pages.workplace.status.processing': '处理中',
  'pages.workplace.status.training': '训练中',
  'pages.workplace.status.testing': '测试中',
  'pages.workplace.status.failed': '失败',
  'pages.workplace.experimentDataImport': '实验数据导入',
  'pages.workplace.simulationDataImport': '仿真数据导入',
  // Task Manager
  'pages.taskManager.taskSubmit': '任务提交',
  'pages.taskManager.taskMonitor': '任务监控',
  'pages.taskManager.resultDownload': '结果下载',
  'pages.taskManager.resultDownload.taskName': '任务名称',
  'pages.taskManager.resultDownload.taskType': '任务类型',
  'pages.taskManager.resultDownload.queryFailed': '查询失败',
  'pages.taskManager.resultDownload.queryFailedRetry': '查询失败，请重试',
  'pages.taskManager.resultDownload.taskTypeLabel': '任务类型',
  'pages.taskManager.resultDownload.completedTime': '完成时间',
  'pages.taskManager.resultDownload.dataPoints': '数据点',
  'pages.taskManager.resultDownload.modelAccuracy': '模型精度',
  'pages.taskManager.resultDownload.saltSystem': '盐体系',
  'pages.taskManager.resultDownload.correlation': '相关性',
  'pages.taskManager.resultDownload.optimizationGoal': '优化目标',
  'pages.taskManager.resultDownload.optimalComposition': '最优成分',
  'pages.taskManager.resultDownload.unnamedTask': '未命名任务',
  'pages.taskManager.resultDownload.startDownloadPng': '开始下载PNG图表',
  'pages.taskManager.resultDownload.startDownloadExcel': '开始下载Excel数据',
  'pages.taskManager.resultDownload.viewChart': '可视化图表',
  'pages.taskManager.resultDownload.downloadResult': '下载结果',
  'pages.taskManager.resultDownload.downloadData': '下载数据',
  'pages.taskManager.resultDownload.downloadReport': '下载报告',
  'pages.taskManager.resultDownload.totalRecords': '共 {total} 条',
  'pages.taskManager.resultDownload.noData': '暂无数据',
  'pages.taskManager.resultDownload.dataStorageManagement': '数据入库管理',
  'pages.taskManager.resultDownload.dataStorageDescription': '将分析结果直接存入数据仓库与知识库，支持后续查询和复用',
  'pages.taskManager.resultDownload.selectTargetDatabase': '选择目标数据库',
  'pages.taskManager.resultDownload.saveToDatabase': '存入数据库',
  'pages.taskManager.resultDownload.linkToKnowledgeGraph': '关联到知识图谱',
  'pages.taskManager.resultDownload.card.taskType': '任务类型',
  'pages.taskManager.resultDownload.card.completedTime': '完成时间',
  'pages.taskManager.resultDownload.card.dataPoints': '数据点',
  'pages.taskManager.resultDownload.card.modelAccuracy': '模型精度',
  'pages.taskManager.resultDownload.card.saltSystem': '盐体系',
  'pages.taskManager.resultDownload.card.correlation': '相关性',
  'pages.taskManager.resultDownload.card.optimizationGoal': '优化目标',
  'pages.taskManager.resultDownload.card.optimalComposition': '最优成分',
  // Task List
  'pages.taskList.getTaskListFailed': '获取任务列表失败',
  'pages.taskList.getTaskListFailedRetry': '获取任务列表失败，请重试',
  'pages.taskList.taskIdNotExists': '任务ID不存在',
  'pages.taskList.confirmPause': '确认暂停',
  'pages.taskList.confirmPauseContent': '确定要暂停任务"{taskName}"吗？',
  'pages.taskList.pauseSuccess': '任务暂停成功',
  'pages.taskList.pauseFailed': '任务暂停失败',
  'pages.taskList.pauseFailedRetry': '任务暂停失败，请重试',
  'pages.taskList.confirmCancel': '确认取消',
  'pages.taskList.confirmCancelContent': '确定要取消任务"{taskName}"吗？',
  'pages.taskList.cancelSuccess': '任务取消成功',
  'pages.taskList.cancelFailed': '任务取消失败',
  'pages.taskList.cancelFailedRetry': '任务取消失败，请重试',
  'pages.taskList.retrySuccess': '任务重试成功',
  'pages.taskList.retryFailed': '任务重试失败',
  'pages.taskList.retryFailedRetry': '任务重试失败，请重试',
  'pages.taskList.statusQueued': '排队中',
  'pages.taskList.statusRunning': '进行中',
  'pages.taskList.statusCompleted': '已完成',
  'pages.taskList.statusFailed': '失败',
  'pages.taskList.statusCancelled': '已取消',
  'pages.taskList.statusUnknown': '未知',
  'pages.taskList.downloadExcelSuccess': 'Excel下载成功',
  'pages.taskList.downloadExcelFailed': 'Excel下载失败',
  'pages.taskList.downloadPngSuccess': 'PNG下载成功',
  'pages.taskList.downloadPngFailed': 'PNG下载失败',
  'pages.taskList.selectDownloadType': '选择下载类型',
  'pages.taskList.excelFile': 'Excel文件',
  'pages.taskList.pngChart': 'PNG图表',
  'pages.taskList.download': '下载',
  'pages.taskList.cancel': '取消',
  'pages.taskList.startDownloadExcel': '开始下载Excel文件',
  'pages.taskList.startDownloadPng': '开始下载PNG图表',
  'pages.taskList.downloadFailedRetry': '下载失败，请重试',
  'pages.taskList.confirmRetry': '确认重试',
  'pages.taskList.confirmRetryContent': '确定要重试任务"{taskName}"吗？',
  'pages.taskList.pause': '暂停',
  'pages.taskList.retry': '重试',
  'pages.taskList.viewDetails': '查看详情',
  'pages.taskList.system': '体系',
  'pages.taskList.temperature': '温度',
  'pages.taskList.compositionRatio': '组分比',
  'pages.taskList.model': '模型',
  'pages.taskList.modelLabel': '模型',
  'pages.taskList.unknownStatus': '未知状态',
  'pages.taskList.completedPercent': '已完成{progress}%',
  'pages.taskList.detail': '详情',
  'pages.taskList.unnamedTask': '未命名任务',
  'pages.taskList.total': '共 {total} 条',
  'pages.taskList.completedPercentWithTime': '已完成{progress}% - 预计剩余时间: {remainingTime}分钟',
  'pages.taskList.queued': '排队中',
  'pages.taskList.queuedWithPosition': '排队中 - 前面有{position}个任务',
  'pages.taskList.completed': '已完成',
  'pages.taskList.completedWithTime': '已完成 - {endTime}',
  'pages.taskList.failed': '失败',
  'pages.taskList.failedWithError': '失败 - {errorMessage}',
  // Task List Details Modal
  'pages.taskList.details.title': '任务详情',
  'pages.taskList.details.getTaskDetailFailed': '获取任务详情失败',
  'pages.taskList.details.getTaskDetailFailedRetry': '获取任务详情失败，请重试',
  'pages.taskList.details.taskInfo': '任务信息',
  'pages.taskList.details.taskId': '任务ID',
  'pages.taskList.details.submitTime': '提交时间',
  'pages.taskList.details.taskType': '任务类型',
  'pages.taskList.details.taskStatus': '任务状态',
  'pages.taskList.details.analysisParams': '分析参数',
  'pages.taskList.details.saltSystem': '盐体系',
  'pages.taskList.details.temperatureRange': '温度范围',
  'pages.taskList.details.fittingModel': '拟合模型',
  'pages.taskList.details.dataPoints': '数据点数',
  'pages.taskList.details.realtimeLogs': '实时日志',
  'pages.taskList.details.noLogs': '暂无日志',
  'pages.taskList.details.previewResult': '预览结果',
  // Experiment Calculate
  'pages.experimentCalculate.workflowOverview': '工作流概述',
  'pages.experimentCalculate.workflowExample': '工作流示例',
  'pages.experimentCalculate.startWorkflow': '启动工作流',
  'pages.experimentCalculate.workflowGoal': '工作流目标',
  'pages.experimentCalculate.workflowOverviewText': '建立实验与仿真的闭环工作流程，实现数据驱动的材料设计与优化。',
  'pages.experimentCalculate.goal1': '实验数据驱动仿真参数优化',
  'pages.experimentCalculate.goal2': '仿真数据补全实验难以测量的极端条件',
  'pages.experimentCalculate.goal3': '形成验证-预测-优化的完整闭环',
  'pages.experimentCalculate.goal4': '加速新材料开发与性能优化',
  'pages.experimentCalculate.viewDetailedGoals': '查看详细目标',
  'pages.experimentCalculate.workflowDiagram': '工作流示意图',
  'pages.experimentCalculate.step1Title': '实验数据',
  'pages.experimentCalculate.step1Desc': '上传实验数据',
  'pages.experimentCalculate.step2Title': '仿真计算',
  'pages.experimentCalculate.step2Desc': '运行仿真模型',
  'pages.experimentCalculate.step3Title': '验证优化',
  'pages.experimentCalculate.step3Desc': '数据对比与校正',
  'pages.experimentCalculate.step4Title': '性能预测',
  'pages.experimentCalculate.step4Desc': '新材料设计优化',
  'pages.experimentCalculate.clickStepsForDetails': '💡 点击各步骤查看详细流程',
  'pages.experimentCalculate.experimentDataDrivenSimulation': '实验数据驱动仿真',
  'pages.experimentCalculate.viscosityDataDriven': '粘度数据驱动',
  'pages.experimentCalculate.viscosityDataDrivenDesc': '上传实验粘度数据(η-T)，系统自动生成MD输入参数，验证并补充扩散系数(D-T)和热导率(λ-T)',
  'pages.experimentCalculate.uploadViscosityData': '上传实验粘度数据',
  'pages.experimentCalculate.generateMdParams': '系统生成MD输入参数',
  'pages.experimentCalculate.verifyAndSupplement': '验证并补充D(T)、λ(T)',
  // Data Import
  'pages.dataImport.batchImport': '批量导入',
  'pages.dataImport.add': '添加',
  'pages.dataImport.importRecord': '导入记录',
  'pages.dataImport.midDataImport': '中间数据导入',
  // Third Import
  'pages.thirdImport.syncSuccess': '同步成功',
  'pages.thirdImport.syncFailed': '同步失败',
  'pages.thirdImport.noSyncTime': '无',
  'pages.thirdImport.featureDeveloping': '功能开发中',
  'pages.thirdImport.latestSync': '最新同步',
  'pages.thirdImport.dataVolume': '数据量',
  'pages.thirdImport.noInfo': '暂无信息',
  'pages.thirdImport.syncCompleted': '同步完成',
  'pages.thirdImport.syncing': '正在同步',
  'pages.thirdImport.unknownStatus': '未知状态',
  // Data Filter
  'pages.dataFilter.system': '体系',
  'pages.dataFilter.physicalType': '物性类型',
  'pages.dataFilter.tempUnit': '温度单位',
  'pages.dataFilter.molComponentRatio': 'MOL组分比',
  'pages.dataFilter.physicalUnit': '物性单位',
  'pages.dataFilter.dataSource': '数据来源',
  'pages.dataFilter.operation': '操作',
  'pages.dataFilter.details': '详情',
  'pages.dataFilter.simulationList': '仿真计算列表',
  'pages.dataFilter.conditionFilterList': '条件筛选列表',
  'pages.dataFilter.selected': '已选',
  'pages.dataFilter.items': '项',
  'pages.dataFilter.clearSelection': '取消选择',
  'pages.dataFilter.exportData': '导出数据',
  'pages.dataFilter.downloadData': '下载数据',
  'pages.dataFilter.cannotGetRecordId': '无法获取记录ID或数据来源',
  'pages.dataFilter.tempRange': '温度区间',
  'pages.dataFilter.minTemp': '最低温度',
  'pages.dataFilter.maxTemp': '最高温度',
  'pages.dataFilter.maxTempMustGreaterThanMin': '最高温度必须大于最低温度',
  'pages.dataFilter.compoundBaseDataInfo': '化合物基础数据信息',
  'pages.dataFilter.index': '序号',
  'pages.dataFilter.component': '组分',
  'pages.dataFilter.coefficient': '系数',
  'pages.dataFilter.getDetailFailed': '获取详情失败',
  'pages.dataFilter.missingParams': '缺少必要参数',
  'pages.dataFilter.detail': '详情',
  'pages.dataFilter.physicalData': '物性数据',
  'pages.dataFilter.importTime': '导入时间',
  'pages.dataFilter.createTime': '创建时间',
  'pages.dataFilter.materialBaseData': '材料基础数据',
  'pages.dataFilter.materialName': '材料名称',
  'pages.dataFilter.meltingPoint': '熔点',
  'pages.dataFilter.boilingPoint': '沸点',
  'pages.dataFilter.thermalStabilityMin': '热稳定性最小值',
  'pages.dataFilter.thermalStabilityMax': '热稳定性最大值',
  'pages.dataFilter.thermalStabilityWidth': '热稳定性宽度',
  'pages.dataFilter.reductionPotential': '还原电位',
  'pages.dataFilter.oxidationPotential': '氧化电位',
  'pages.dataFilter.corrosionPotential': '腐蚀电位',
  'pages.dataFilter.corrosive': '腐蚀性',
  'pages.dataFilter.electrochemistryMin': '电化学最小值',
  'pages.dataFilter.electrochemistryMax': '电化学最大值',
  'pages.dataFilter.factorData': '因子数据',
  // Material Properties
  'pages.materialProperties.compoundBasicInfo': '化合物基础数据信息',
  'pages.materialProperties.system': '体系',
  'pages.materialProperties.physicalType': '物性类型',
  'pages.materialProperties.dataSource': '数据来源',
  'pages.materialProperties.physicalUnit': '物性单位',
  'pages.materialProperties.tempMin': '温度下限',
  'pages.materialProperties.tempMax': '温度上限',
  'pages.materialProperties.meltingPoint': '熔点',
  'pages.materialProperties.boilingPoint': '沸点',
  'pages.materialProperties.thermalStabilityWidth': '热稳定性宽度',
  'pages.materialProperties.corrosivity': '腐蚀性',
  'pages.materialProperties.corrosionPotential': '腐蚀电位',
  'pages.materialProperties.serialNumber': '序号',
  'pages.materialProperties.component': '组分',
  'pages.materialProperties.coefficient': '系数',
  'pages.materialProperties.createTime': '创建时间',
  'pages.materialProperties.details': '详情',
  'pages.materialProperties.tempUnit': '温度单位',
  'pages.materialProperties.index': '序号',
  'pages.materialProperties.measuredValue': '实测值',
  'pages.materialProperties.temperature': '温度',
  'pages.materialProperties.unitConversion': '单位转换',
  'pages.materialProperties.convert': '转换',
  'pages.materialProperties.compoundBaseDataInfo': '化合物基础数据信息',
  // Unit Conversion
  'pages.unitConversion.loadUnitsFailed': '加载单位列表失败',
  'pages.unitConversion.invalidTargetUnit': '无效的目标单位',
  'pages.unitConversion.convertSuccess': '转换成功',
  'pages.unitConversion.convertFailed': '转换失败，请稍后重试',
  'pages.unitConversion.title': '单位转换',
  'pages.unitConversion.cancel': '取消',
  'pages.unitConversion.convert': '转换',
  'pages.unitConversion.measuredValue': '实测值',
  'pages.unitConversion.measuredValueRequired': '请输入实测值',
  'pages.unitConversion.measuredValuePlaceholder': '请输入实测值',
  'pages.unitConversion.physicalType': '物性类型',
  'pages.unitConversion.physicalTypePlaceholder': '物性类型',
  'pages.unitConversion.originalUnit': '原物性单位',
  'pages.unitConversion.originalUnitPlaceholder': '原物性单位',
  'pages.unitConversion.targetUnit': '目标物性单位',
  'pages.unitConversion.targetUnitRequired': '请选择目标物性单位',
  'pages.unitConversion.targetUnitPlaceholder': '请选择目标物性单位',
  'pages.unitConversion.result': '转换结果',
  // Experiment Result
  'pages.experimentResult.experimentData': '物性试验数据',
  'pages.experimentResult.system': '体系',
  'pages.experimentResult.physicalType': '物性类型',
  'pages.experimentResult.physicalUnit': '物性单位',
  'pages.experimentResult.dataSource': '数据来源',
  'pages.experimentResult.tempUnit': '温度单位',
  'pages.experimentResult.index': '序号',
  'pages.experimentResult.component': '组分',
  'pages.experimentResult.measuredValue': '实测值',
  'pages.experimentResult.temperature': '温度',
  'pages.experimentResult.coefficient': '系数',
  // Statistics Analysis
  'pages.statisticsAnalysis.system': '体系',
  'pages.statisticsAnalysis.physicalType': '物性类型',
  'pages.statisticsAnalysis.dataSource': '数据来源',
  'pages.statisticsAnalysis.temperatureRange': '温度范围',
  'pages.statisticsAnalysis.systemRequired': '体系为必填项，请输入体系',
  'pages.statisticsAnalysis.physicalTypeRequired': '物性类型为必填项，请先选择物性类型',
  // Data Flow
  'pages.dataFlow.all': '全部',
  'pages.dataFlow.taskNo': '任务编号',
  'pages.dataFlow.taskName': '任务名称',
  'pages.dataFlow.dataSourceType': '数据来源类型',
  'pages.dataFlow.dataSource': '数据来源',
  'pages.dataFlow.fileFormat': '文件格式',
  'pages.dataFlow.taskStatus': '任务状态',
  'pages.dataFlow.totalProgress': '总进度',
  'pages.dataFlow.totalRecords': '总记录数',
  'pages.dataFlow.createTime': '创建时间',
  'pages.dataFlow.operation': '操作',
  'pages.dataFlow.viewDetails': '查看详情',
  'pages.dataFlow.status.pending': '待处理',
  'pages.dataFlow.status.extracting': '抽取中',
  'pages.dataFlow.status.transforming': '转换中',
  'pages.dataFlow.status.loading': '加载中',
  'pages.dataFlow.status.completed': '已完成',
  'pages.dataFlow.status.failed': '失败',
  // Home
  'pages.home.getStatisticsFailed': '获取统计数据失败',
  'pages.home.getStatisticsFailedRetry': '获取统计数据失败，请稍后重试',
  'pages.home.materialCount': '材料数',
  'pages.home.experimentRecord': '实验记录',
  'pages.home.modelCount': '模型数',
  'pages.home.month.january': '一月',
  'pages.home.month.february': '二月',
  'pages.home.month.march': '三月',
  'pages.home.month.april': '四月',
  'pages.home.month.may': '五月',
  'pages.home.month.june': '六月',
  // Chart Generate
  'pages.chartGenerate.success': '图表生成成功',
  'pages.chartGenerate.failed': '图表生成失败',
  'pages.chartGenerate.queryFailed': '查询失败，请稍后重试',
  'pages.chartGenerate.generateChartFirst': '请先生成图表',
  'pages.chartGenerate.generatingImages': '正在生成图表图片...',
  'pages.chartGenerate.uploadingToServer': '正在上传到服务器...',
  'pages.chartGenerate.downloadingPDF': '正在下载PDF文件...',
  'pages.chartGenerate.imageGenerationFailed': '图表图片生成失败',
  'pages.chartGenerate.exportSuccess': 'PDF导出成功',
  'pages.chartGenerate.exportFailed': 'PDF导出失败',
  'pages.chartGenerate.lineChart': '折线图',
  'pages.chartGenerate.barChart': '柱状图',
  'pages.chartGenerate.scatterChart': '散点图',
  'pages.chartGenerate.chartType': '图表类型',
  'pages.chartGenerate.pleaseSelectChartType': '请选择图表类型',
  'pages.chartGenerate.physicalType': '物性类型',
  'pages.chartGenerate.pleaseSelectPhysicalType': '请选择物性类型',
  'pages.chartGenerate.temperature': '温度',
  'pages.chartGenerate.minTemp': '最小温度',
  'pages.chartGenerate.maxTemp': '最大温度',
  'pages.chartGenerate.maxTempMustGreaterThanMin': '最大温度必须大于最小温度',
  'pages.chartGenerate.system': '体系',
  'pages.chartGenerate.pleaseInputSystem': '请输入体系',
  'pages.chartGenerate.generateChart': '生成图表',
  'pages.chartGenerate.reset': '重置',
  // Data Export
  'pages.dataExport.invalidImageData': '图表图片数据格式不正确',
  'pages.dataExport.noResponse': '导出接口无响应',
  'pages.dataExport.exportFailed': '导出接口返回失败状态',
  'pages.dataExport.experimentData': '实验数据',
  'pages.dataExport.literatureData': '文献数据',
  'pages.dataExport.simulationData': '仿真数据',
  // Performance Candidate
  'pages.performanceCandidate.loadTempUnitsFailed': '加载温度单位失败',
  'pages.performanceCandidate.reverseCompleted': '反推完成！',
  'pages.performanceCandidate.reverseFailed': '反推失败，请重试',
  'pages.performanceCandidate.formReset': '表单已重置',
  'pages.performanceCandidate.saltComponent': '盐组分',
  'pages.performanceCandidate.minMolarRatio': '最小摩尔比 (mol%)',
  'pages.performanceCandidate.maxMolarRatio': '最大摩尔比 (mol%)',
  'pages.performanceCandidate.recommendedMolarRatio': '推荐摩尔比 (mol%)',
  'pages.performanceCandidate.candidateCombination': '候选组合 {index}',
  'pages.performanceCandidate.matchScore': '匹配度',
  'pages.performanceCandidate.predictedPerformance': '预测性能指标',
  'pages.performanceCandidate.molarRatioRange': '摩尔比范围',
  'pages.performanceCandidate.otherProperties': '其他物性参数',
  'pages.performanceCandidate.unknown': '未知',
  'pages.performanceCandidate.recommendationReason': '推荐理由',
  'pages.performanceCandidate.physicalPropType': '物性类型',
  'pages.performanceCandidate.physicalPropType.required': '请选择物性类型',
  'pages.performanceCandidate.physicalPropType.placeholder': '请选择物性类型',
  'pages.performanceCandidate.rangeType': '性能指标范围类型',
  'pages.performanceCandidate.rangeType.required': '请选择范围类型',
  'pages.performanceCandidate.rangeType.placeholder': '请选择范围类型',
  'pages.performanceCandidate.minValue': '性能指标最小值',
  'pages.performanceCandidate.minValue.required': '请输入性能指标最小值',
  'pages.performanceCandidate.minValue.placeholder': '请输入最小值',
  'pages.performanceCandidate.maxValue': '性能指标最大值',
  'pages.performanceCandidate.maxValue.required': '请输入性能指标最大值',
  'pages.performanceCandidate.maxValue.placeholder': '请输入最大值',
  'pages.performanceCandidate.physicalUnit': '性能指标单位',
  'pages.performanceCandidate.physicalUnit.placeholder': '例如:W/m·K、mPa·s、g/cm³',
  'pages.performanceCandidate.workTempRange': '工作温度区间',
  'pages.performanceCandidate.workTempMin.required': '请输入最小温度',
  'pages.performanceCandidate.workTempMin.placeholder': '最小温度',
  'pages.performanceCandidate.workTempMax.required': '请输入最大温度',
  'pages.performanceCandidate.workTempMax.placeholder': '最大温度',
  'pages.performanceCandidate.tempUnit': '温度单位',
  'pages.performanceCandidate.tempUnit.placeholder': '请选择温度单位',
  'pages.performanceCandidate.algorithmType': '算法类型',
  'pages.performanceCandidate.algorithmType.placeholder': '请选择算法类型',
  'pages.performanceCandidate.recommendCount': '候选材料个数',
  'pages.performanceCandidate.positiveInteger': '请输入正整数',
  'pages.performanceCandidate.integer': '请输入整数',
  'pages.performanceCandidate.recommendCount.placeholder': '请输入候选材料个数',
  'pages.performanceCandidate.matchScore.range': '请输入0-100之间的数值',
  'pages.performanceCandidate.matchScore.placeholder': '请输入最低匹配度(0-100)',
  'pages.performanceCandidate.start': '开始反推',
  'pages.performanceCandidate.reset': '重置',
  'pages.performanceCandidate.reversing': '正在反推中...',
  'pages.performanceCandidate.emptyDescription1': '请在左侧填写查询条件并点击"开始反推"',
  'pages.performanceCandidate.emptyDescription2': '反推结果将显示在这里',
  'pages.performanceCandidate.resultTitle': '反推结果',
  'pages.performanceCandidate.noResult': '暂无反推结果',
  // Replace Recommend
  'pages.replaceRecommend.completed': '推荐完成！',
  'pages.replaceRecommend.failed': '推荐失败，请重试',
  'pages.replaceRecommend.formReset': '表单已重置',
  'pages.replaceRecommend.candidateSystem': '候选体系',
  'pages.replaceRecommend.matchScore': '匹配度',
  'pages.replaceRecommend.applicationMatch': '应用场景匹配度',
  'pages.replaceRecommend.thermalStability': '热稳定性',
  'pages.replaceRecommend.corrosionCompatibility': '腐蚀性兼容性',
  'pages.replaceRecommend.properties': '物性参数',
  'pages.replaceRecommend.unknown': '未知',
  'pages.replaceRecommend.recommendationReason': '推荐理由',
  'pages.replaceRecommend.applicationScenario': '目标应用场景',
  'pages.replaceRecommend.applicationScenario.required': '请输入目标应用场景',
  'pages.replaceRecommend.maxLength': '最多输入500个字符',
  'pages.replaceRecommend.applicationScenario.placeholder': '例如: 900℃ 热能存储',
  'pages.replaceRecommend.recommendMethod': '推荐方法',
  'pages.replaceRecommend.recommendMethod.placeholder': '请选择推荐方法',
  'pages.replaceRecommend.recommendCount': '候选材料个数',
  'pages.replaceRecommend.positiveInteger': '请输入正整数',
  'pages.replaceRecommend.integer': '请输入整数',
  'pages.replaceRecommend.recommendCount.placeholder': '请输入候选材料个数',
  'pages.replaceRecommend.matchScore.range': '请输入0-100之间的数值',
  'pages.replaceRecommend.matchScore.placeholder': '请输入最低匹配度(0-100)',
  'pages.replaceRecommend.additionalConditions': '附加条件 (可选)',
  'pages.replaceRecommend.conditionType.required': '请选择条件类型',
  'pages.replaceRecommend.conditionType.placeholder': '条件类型',
  'pages.replaceRecommend.conditionDescription.required': '请输入条件描述',
  'pages.replaceRecommend.conditionDescription.placeholder': '例如: Hastelloy-N 腐蚀速率 < 50 μm/年',
  'pages.replaceRecommend.addCondition': '添加条件',
  'pages.replaceRecommend.start': '开始推荐',
  'pages.replaceRecommend.reset': '重置',
  'pages.replaceRecommend.recommending': '正在推荐中...',
  'pages.replaceRecommend.emptyDescription1': '请在左侧填写查询条件并点击"开始推荐"',
  'pages.replaceRecommend.emptyDescription2': '推荐结果将显示在这里',
  'pages.replaceRecommend.resultTitle': '推荐结果',
  'pages.replaceRecommend.noResult': '暂无推荐结果',
  // Dig Result
  'pages.digResult.systemKeywords': '体系关键字',
  'pages.digResult.all': '全部',
  'pages.digResult.queryFailed': '查询失败，请稍后重试',
  'pages.digResult.meltingPoint': '熔点',
  'pages.digResult.physicalProperty': '物性',
  'pages.digResult.dataSource': '数据来源',
  'pages.digResult.documentOverview': '文献数据概览',
  'pages.digResult.noData': '暂无数据，请进行查询',
  'pages.digResult.system': '体系 {index}',
  'pages.digResult.systemIncomplete': '体系信息不完整，无法查看对比分析',
  'pages.digResult.viewCompare': '查看对比分析',
  // Location Manage
  'pages.locationManage.totalLocations': '库位总数',
  'pages.locationManage.disabledCount': '禁用数',
  'pages.locationManage.edit': '编辑',
  'pages.locationManage.entryPort': '入货口',
  'pages.locationManage.exitPort': '出货口',
  // Add Location
  'pages.addLocation.aisleRow': '巷道/排',
  'pages.addLocation.layerColumn': '层列',
  'pages.addLocation.next': '下一步',
  'pages.addLocation.cancel': '取消',
  'pages.addLocation.previous': '上一步',
  'pages.addLocation.save': '保存',
  // Ship Manage
  'pages.shipManage.creator': '创建人',
  'pages.shipManage.startEndTime': '起止时间',
  'pages.shipManage.createTime': '创建时间',
  'pages.shipManage.component1': '组分1',
  'pages.shipManage.component2': '组分2',
  'pages.shipManage.component3': '组分3',
  'pages.shipManage.component4': '组分4',
  'pages.shipManage.component5': '组分5',
  // Model Train
  'pages.modelTrain.modelTraining': '模型训练',
  'pages.modelTrain.modelTesting': '模型测试',
  // Model Train Tab
  'pages.modelTrain.trainingName': '训练名称',
  'pages.modelTrain.trainingNameRequired': '请输入训练名称',
  'pages.modelTrain.trainingNamePlaceholder': '请输入',
  'pages.modelTrain.selectModel': '选择模型',
  'pages.modelTrain.selectModelRequired': '请选择模型',
  'pages.modelTrain.selectModelPlaceholder': '请选择模型',
  'pages.modelTrain.selectVersion': '选择版本',
  'pages.modelTrain.selectVersionRequired': '请选择版本',
  'pages.modelTrain.selectVersionPlaceholder': '请选择版本',
  'pages.modelTrain.trainingSet': '训练集',
  'pages.modelTrain.validationSet': '验证集',
  'pages.modelTrain.paramList': '参数列表',
  'pages.modelTrain.paramName': '参数名称',
  'pages.modelTrain.paramValue': '参数值',
  'pages.modelTrain.paramValueRequired': '请输入{paramName}',
  'pages.modelTrain.paramValuePlaceholder': '请输入',
  'pages.modelTrain.trainingRatio': '训练比率',
  'pages.modelTrain.crossValidation': '交叉验证',
  'pages.modelTrain.trainingTimes': '训练次数',
  'pages.modelTrain.trainingTimesRequired': '请输入训练次数',
  'pages.modelTrain.trainingTimesPlaceholder': '请输入',
  'pages.modelTrain.startTraining': '开始训练',
  'pages.modelTrain.trainingConfig': '训练配置',
  'pages.modelTrain.trainingProgressAndResult': '训练进度和结果',
  'pages.modelTrain.accuracy': '准确率',
  'pages.modelTrain.lossValue': '损失值',
  'pages.modelTrain.trainingProgress': '训练进度',
  'pages.modelTrain.accuracyTrend': '准确率趋势',
  'pages.modelTrain.noChartData': '暂无图表数据',
  'pages.modelTrain.selectTrainingRecord': '请选择一条训练记录查看结果',
  'pages.modelTrain.queuedTraining': '排队中的训练',
  'pages.modelTrain.historyTraining': '历史训练模型',
  'pages.modelTrain.modelName': '模型名称',
  'pages.modelTrain.trainingTime': '训练时间',
  'pages.modelTrain.trainingDuration': '训练时长',
  'pages.modelTrain.status': '状态',
  'pages.modelTrain.operation': '操作',
  'pages.modelTrain.details': '详情',
  'pages.modelTrain.trainingDetail': '训练详情',
  'pages.modelTrain.close': '关闭',
  'pages.modelTrain.basicInfo': '基本信息',
  'pages.modelTrain.trainingStatus': '训练状态',
  'pages.modelTrain.startTime': '开始时间',
  'pages.modelTrain.endTime': '结束时间',
  'pages.modelTrain.epochs': '训练次数',
  'pages.modelTrain.trainingSetRatio': '训练集比例',
  'pages.modelTrain.failureReason': '失败原因',
  'pages.modelTrain.paramConfig': '参数配置',
  'pages.modelTrain.trainingSetParamConfig': '训练集参数配置',
  'pages.modelTrain.validationSetParamConfig': '验证集参数配置',
  'pages.modelTrain.trainingResult': '训练结果',
  'pages.modelTrain.loadModelListFailed': '加载模型列表失败',
  'pages.modelTrain.loadVersionListFailed': '加载版本列表失败',
  'pages.modelTrain.loadParamListFailed': '加载参数列表失败',
  'pages.modelTrain.createTrainingSuccess': '训练任务创建成功',
  'pages.modelTrain.createTrainingFailed': '创建训练任务失败',
  'pages.modelTrain.selectModelAndVersion': '请选择模型和版本',
  'pages.modelTrain.loadTrainingDetailFailed': '加载训练详情失败',
  'pages.modelTrain.loadTrainingResultFailed': '加载训练结果失败',
  // Model Test Tab
  'pages.modelTest.testingName': '测试名称',
  'pages.modelTest.testingNameRequired': '请输入测试名称',
  'pages.modelTest.testingNamePlaceholder': '请输入',
  'pages.modelTest.testingTimes': '测试次数',
  'pages.modelTest.testingTimesRequired': '请输入测试次数',
  'pages.modelTest.testingTimesPlaceholder': '请输入',
  'pages.modelTest.startTesting': '开始测试',
  'pages.modelTest.testingConfig': '测试配置',
  'pages.modelTest.testingProgressAndResult': '测试进度和结果',
  'pages.modelTest.evaluationMetric': '评估指标',
  'pages.modelTest.accuracy': '准确率',
  'pages.modelTest.rSquared': 'R平方值',
  'pages.modelTest.lossValue': '损失值',
  'pages.modelTest.noEvaluationData': '暂无评估指标数据',
  'pages.modelTest.predictionScatter': '预测散点图',
  'pages.modelTest.noScatterData': '暂无散点图数据',
  'pages.modelTest.errorDistribution': '误差分布',
  'pages.modelTest.noErrorData': '暂无误差分布数据',
  'pages.modelTest.selectTestingRecord': '请选择一条测试记录查看结果',
  'pages.modelTest.testingSummary': '测试摘要',
  'pages.modelTest.noRunningTesting': '暂无运行中的测试任务',
  'pages.modelTest.loadedAllData': '已加载全部数据',
  'pages.modelTest.unnamedTesting': '未命名测试',
  'pages.modelTest.unknownStatus': '未知状态',
  'pages.modelTest.model': '模型',
  'pages.modelTest.version': '版本',
  'pages.modelTest.detailedTestingResult': '详细测试结果',
  'pages.modelTest.testingTime': '测试时间',
  'pages.modelTest.viewDetails': '查看详情',
  'pages.modelTest.loadModelListFailed': '加载模型列表失败',
  'pages.modelTest.loadVersionListFailed': '加载版本列表失败',
  'pages.modelTest.loadParamListFailed': '加载参数列表失败',
  'pages.modelTest.loadTestingRecordFailed': '加载测试记录失败',
  'pages.modelTest.loadTestingResultFailed': '加载测试结果失败',
  'pages.modelTest.createTestingSuccess': '测试任务创建成功',
  'pages.modelTest.createTestingFailed': '创建测试任务失败',
  'pages.modelTest.selectModelAndVersion': '请选择模型和版本',
  // Model List
  'pages.modelList.noRunningTraining': '暂无运行中的训练任务',
  'pages.modelList.loadedAllData': '已加载全部数据',
  'pages.modelList.unnamedTraining': '未命名训练',
  'pages.modelList.unknownStatus': '未知状态',
  'pages.modelList.loadTrainingRecordFailed': '加载训练记录失败',
  // Model Connect
  'pages.modelConnect.taskName': '任务名称',
  'pages.modelConnect.taskType': '任务类型',
  'pages.modelConnect.taskStatus': '任务状态',
  'pages.modelConnect.taskId': '任务ID',
  'pages.modelConnect.createTime': '创建时间',
  'pages.modelConnect.finishTime': '完成时间',
  'pages.modelConnect.taskDescription': '任务描述',
  'pages.modelConnect.operation': '操作',
  'pages.modelConnect.details': '详情',
  'pages.modelConnect.download': '下载',
  'pages.modelConnect.taskIdNotExists': '任务ID不存在，无法查看详情',
  'pages.modelConnect.status.completed': '已完成',
  'pages.modelConnect.status.complete': '完成',
  'pages.modelConnect.status.success': '成功',
  'pages.modelConnect.status.processing': '处理中',
  'pages.modelConnect.status.running': '运行中',
  'pages.modelConnect.status.inProgress': '进行中',
  'pages.modelConnect.status.pending': '待处理',
  'pages.modelConnect.status.queued': '排队',
  'pages.modelConnect.status.waiting': '等待',
  'pages.modelConnect.status.failed': '失败',
  'pages.modelConnect.status.error': '错误',
  // Experiment
  'pages.experiment.syncingAllData': '正在同步所有外部系统数据...',
  'pages.experiment.syncCompleted': '同步完成',
  'pages.experiment.limsIntegration': 'LIMS系统对接',
  'pages.experiment.plmIntegration': 'PLM系统对接',
  'pages.experiment.simulationIntegration': '仿真平台对接',
  'pages.experiment.externalSystemIntegration': '外部系统对接管理平台',
  'pages.experiment.syncAllData': '同步所有数据',
  'pages.experiment.limsData': 'LIMS实验数据',
  'pages.experiment.plmFormula': 'PLM配方数量',
  'pages.experiment.simulationTask': '仿真任务数',
  'pages.experiment.todaySync': '今日同步',
  // Configuration Manager
  'pages.configurationManager.metadata': '元数据',
  'pages.configurationManager.isPhysical': '是否为物性',
  'pages.configurationManager.yes': '是',
  'pages.configurationManager.no': '否',
  'pages.configurationManager.serialNumber': '序号',
  'pages.configurationManager.metadataEnName': '元素英文名称',
  'pages.configurationManager.unitName': '单位名称',
  'pages.configurationManager.unitEnName': '单位英文名称',
  'pages.configurationManager.unit': '单位',
  'pages.configurationManager.lastModifyTime': '最近一次修改时间',
  'pages.configurationManager.lastModifyUser': '最近一次修改人',
  'pages.configurationManager.deleteSuccess': '删除成功',
  'pages.configurationManager.deleteFailed': '删除失败，请重试',
  'pages.configurationManager.confirmDelete': '确定要删除这条元数据吗？',
  // Home Page
  'pages.home.systemTitle': '熔盐物性数据管理与智能分析系统',
  'pages.home.systemSubtitle': '基于人工智能的材料科学数据平台',
  'pages.home.totalDataCount': '总数据量',
  'pages.home.continuousGrowth': '持续增长',
  'pages.home.activeModel': '活跃模型',
  'pages.home.running': '运行中',
  'pages.home.runningTask': '运行任务',
  'pages.home.realTimeUpdate': '实时更新',
  'pages.home.dataOverview': '数据总览',
  'pages.home.intelligentAnalysis': '智能分析',
  'pages.home.performanceMonitorModel': '性能监测模型 (准确率)',
  'pages.home.anomalyMonitorModel': '异常监测模型 (准确率)',
  'pages.home.taskMonitor': '任务监控',
  'pages.home.completed': '已完成',
  'pages.home.queued': '队列中',
  'pages.home.dataGrowthTrend': '数据增长趋势',
  'pages.home.monthlyGrowthRate': '月增长率',
  'pages.home.quickActions': '快捷操作',
  'pages.home.dataUpload': '数据上传',
  'pages.home.dataAnalysis': '数据分析',
  'pages.home.dataVisualization': '数据可视化',
  'pages.home.modelTraining': '模型训练',
  'pages.home.systemStatus': '系统状态',
  'pages.home.database': '数据库',
  'pages.home.normal': '正常',
  'pages.home.apiService': 'API服务',
  'pages.home.storageSpace': '存储空间',
  'pages.home.materialTypeStatistics': '熔盐材料分类统计',
  'pages.home.fluoride': '氟化物',
  'pages.home.chloride': '氯化物',
  'pages.home.nitrate': '硝酸盐',
  'pages.home.carbonate': '碳酸盐',
  'pages.home.other': '其他',
  'pages.home.materialPropertyOverview': '材料物性参数概览',
  'pages.home.avgMeltingPoint': '平均熔点',
  'pages.home.avgHeatCapacity': '平均热容',
  'pages.home.avgThermalConductivity': '平均热导率',
  'pages.home.avgDensity': '平均密度',
  'pages.home.temperatureRange': '温度范围',
  'pages.home.meltingPoint': '熔点',
  'pages.home.heatCapacity': '热容',
  'pages.home.dataSourceStatistics': '数据来源统计',
  'pages.home.experimentData': '实验数据',
  'pages.home.simulationCalculation': '仿真计算',
  'pages.home.literatureData': '文献资料',
  'pages.home.dataQualityScore': '数据质量评分',
  'pages.home.comprehensiveIntegrity': '综合完整性、准确性、可信度',
  'pages.home.dataTrendAnalysis': '数据趋势分析',
  'pages.home.monthlyNewData': '本月新增',
  'pages.home.dataIntegrity': '数据完整性',
  'pages.home.pendingReviewData': '待审核数据',
  'pages.home.verifiedData': '已验证数据',
  'pages.home.recentMaterials': '最近添加的材料',
  'pages.home.temperatureRangeDistribution': '适用温度范围分布',
  'pages.home.lowTemp': '低温 (< 400°C)',
  'pages.home.midTemp': '中温 (400-700°C)',
  'pages.home.highTemp': '高温 (> 700°C)',
  'pages.home.popularMaterials': '热门材料推荐',
  'pages.home.hot': '热门',
  'pages.home.usageCount': '使用次数',
  'pages.home.application': '应用',
  // Data Export
  'pages.dataExport.getDataFailed': '获取数据失败',
  'pages.dataExport.getDataFailedRetry': '获取数据失败，请重试',
  'pages.dataExport.noDataToExport': '暂无数据可导出，请先查询',
  'pages.dataExport.fillSystemAndPhysicalType': '请先填写并查询体系与物性类型',
  'pages.dataExport.chartNotReady': '图表尚未准备完毕，请稍后再试',
  'pages.dataExport.generatingReport': '正在生成报告，请稍候...',
  'pages.dataExport.generateChartImageFailed': '生成图表图片失败',
  'pages.dataExport.chartUploadFailed': '图表上传失败',
  'pages.dataExport.reportExportSuccess': '报告导出成功',
  'pages.dataExport.reportExportFailed': '报告导出失败，请稍后重试',
  'pages.dataExport.includePhysicalSubstance': '包含物性物质',
  'pages.dataExport.includeMetadata': '包含元数据（试验条件等）',
  'pages.dataExport.includeFormulaAndCurve': '包含拟合公式和曲线',
  'pages.dataExport.materialParams': '材料参数',
  'pages.dataExport.pleaseQueryFirst': '请先输入查询条件进行查询',
  'pages.dataExport.physicalData': '物性数据',
  'pages.dataExport.physicalAnalysisAndFitting': '物性分析与拟合',
  'pages.dataExport.noDataPleaseQuery': '暂无数据，请先查询物性数据',
  'pages.dataExport.exportOptions': '导出选项',
  'pages.dataExport.exportExcel': '导出Excel',
  'pages.dataExport.exportPDF': '导出PDF',
  'pages.dataExport.generateAndExportReport': '生成并导出报告',
  // Model Connect
  'pages.modelConnect.multiscaleModelingTaskList': '多尺度建模任务列表',
  'pages.modelConnect.createMdTask': '新建MD任务',
  'pages.modelConnect.createDftTask': '新建DFT任务',
  'pages.modelConnect.totalRecords': '共 {total} 条',
  'pages.modelConnect.dftTaskModal.title': '新建DFT对接任务',
  'pages.modelConnect.dftTaskModal.taskName': '任务名称',
  'pages.modelConnect.dftTaskModal.taskNameRequired': '请输入任务名称',
  'pages.modelConnect.dftTaskModal.taskNamePlaceholder': '请输入任务名称',
  'pages.modelConnect.dftTaskModal.taskDescription': '任务描述',
  'pages.modelConnect.dftTaskModal.taskDescriptionPlaceholder': '请输入任务描述（可选）',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnit': '盐分子单元',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnitExtra': '例如：LiF、ThF4、UF4',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnitPlaceholder': '请输入盐分子单元',
  'pages.modelConnect.dftTaskModal.electronicStructureCalc': '电子结构计算参数（JSON格式）',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcExtra': '例如：{"method": "DFT", "basis_set": "6-31G", "functional": "B3LYP"}',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcPlaceholder': '例如：{"method": "DFT", "basis_set": "6-31G", "functional": "B3LYP"}',
  'pages.modelConnect.dftTaskModal.calculationParams': '计算参数（JSON格式）',
  'pages.modelConnect.dftTaskModal.calculationParamsExtra': '例如：{"convergence": 1e-6, "max_iterations": 100}',
  'pages.modelConnect.dftTaskModal.calculationParamsPlaceholder': '例如：{"convergence": 1e-6, "max_iterations": 100}',
  'pages.modelConnect.dftTaskModal.inputFile': '输入文件（可选）',
  'pages.modelConnect.dftTaskModal.inputFileExtra': '请上传文件，上传成功后会自动填写文件ID',
  'pages.modelConnect.dftTaskModal.uploadText': '点击或拖拽文件到此区域上传',
  'pages.modelConnect.dftTaskModal.uploadHint': '支持单文件上传',
  'pages.modelConnect.dftTaskModal.createTask': '创建任务',
  'pages.modelConnect.dftTaskModal.uploadSuccess': '{fileName} 上传成功！',
  'pages.modelConnect.dftTaskModal.uploadFailed': '{fileName} 上传失败！',
  'pages.modelConnect.dftTaskModal.fileIdNotReturned': '文件上传成功，但未返回文件ID！',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcError': '电子结构计算参数格式错误，请输入合法的 JSON',
  'pages.modelConnect.dftTaskModal.calculationParamsError': '计算参数格式错误，请输入合法的 JSON',
  'pages.modelConnect.dftTaskModal.createSuccess': '新建DFT任务成功',
  'pages.modelConnect.dftTaskModal.createFailed': '新建DFT任务失败',
  'pages.modelConnect.dftTaskModal.createFailedRetry': '新建DFT任务失败，请重试',
  'pages.modelConnect.mdTaskModal.title': '新建MD对接任务',
  'pages.modelConnect.mdTaskModal.saltSystem': '多组分盐体系',
  'pages.modelConnect.mdTaskModal.saltSystemRequired': '请输入多组分盐体系',
  'pages.modelConnect.mdTaskModal.saltSystemExtra': '例如：LiF–ThF₄–UF₄',
  'pages.modelConnect.mdTaskModal.saltSystemPlaceholder': '例如：LiF–ThF₄–UF₄',
  'pages.modelConnect.mdTaskModal.temperature': '温度值',
  'pages.modelConnect.mdTaskModal.temperatureRequired': '请输入温度值',
  'pages.modelConnect.mdTaskModal.temperatureUnit': '温度单位',
  'pages.modelConnect.mdTaskModal.temperatureUnitPlaceholder': '请选择温度单位',
  'pages.modelConnect.mdTaskModal.pressure': '压力值',
  'pages.modelConnect.mdTaskModal.pressureUnit': '压力单位',
  'pages.modelConnect.mdTaskModal.pressureUnitPlaceholder': '例如：bar',
  'pages.modelConnect.mdTaskModal.potentialFunctionSource': '势函数来源',
  'pages.modelConnect.mdTaskModal.potentialFunctionSourceRequired': '请选择势函数来源',
  'pages.modelConnect.mdTaskModal.potentialFunctionSourcePlaceholder': '请选择势函数来源',
  'pages.modelConnect.mdTaskModal.dftResultId': '关联DFT结果ID',
  'pages.modelConnect.mdTaskModal.dftResultIdExtra': '仅当势函数来源为DFT时需要填写',
  'pages.modelConnect.mdTaskModal.saltComposition': '盐组分信息（JSON格式）',
  'pages.modelConnect.mdTaskModal.saltCompositionExtra': '例如：{"LiF": 0.5, "ThF4": 0.3, "UF4": 0.2}',
  'pages.modelConnect.mdTaskModal.saltCompositionPlaceholder': '例如：{"LiF": 0.5, "ThF4": 0.3, "UF4": 0.2}',
  'pages.modelConnect.mdTaskModal.simulationParams': '模拟参数（JSON格式）',
  'pages.modelConnect.mdTaskModal.simulationParamsPlaceholder': '例如：{"ensemble": "NVT", "time_step": 0.001, "total_time": 1000}',
  'pages.modelConnect.mdTaskModal.saltCompositionError': '盐组分信息格式错误，请输入合法的 JSON',
  'pages.modelConnect.mdTaskModal.simulationParamsError': '模拟参数格式错误，请输入合法的 JSON',
  'pages.modelConnect.mdTaskModal.createSuccess': '新建MD任务成功',
  'pages.modelConnect.mdTaskModal.createFailed': '新建MD任务失败',
  'pages.modelConnect.mdTaskModal.createFailedRetry': '新建MD任务失败，请重试',
  'pages.modelConnect.taskDetailsModal.title': '任务详情',
  'pages.modelConnect.taskDetailsModal.taskInfo': '任务信息',
  'pages.modelConnect.taskDetailsModal.dftTaskInfo': 'DFT任务信息',
  'pages.modelConnect.taskDetailsModal.mdTaskInfo': 'MD任务信息',
  'pages.modelConnect.taskDetailsModal.saltMoleculeUnit': '盐分子单元',
  'pages.modelConnect.taskDetailsModal.inputFilePath': '输入文件路径',
  'pages.modelConnect.taskDetailsModal.outputFilePath': '输出文件路径',
  'pages.modelConnect.taskDetailsModal.bindingEnergy': '结合能',
  'pages.modelConnect.taskDetailsModal.ionPotential': '离子势',
  'pages.modelConnect.taskDetailsModal.resultFilePath': '结果文件路径',
  'pages.modelConnect.taskDetailsModal.saltSystem': '多组分盐体系',
  'pages.modelConnect.taskDetailsModal.temperature': '温度',
  'pages.modelConnect.taskDetailsModal.pressure': '压力',
  'pages.modelConnect.taskDetailsModal.potentialFunctionSource': '势函数来源',
  'pages.modelConnect.taskDetailsModal.dftResultId': '关联DFT结果ID',
  'pages.modelConnect.taskDetailsModal.diffusionCoefficient': '扩散系数',
  'pages.modelConnect.taskDetailsModal.thermalConductivity': '热导率',
  'pages.modelConnect.taskDetailsModal.viscosity': '黏度',
  'pages.modelConnect.taskDetailsModal.getDetailFailed': '获取任务详情失败',
  // Audit Compliance
  'pages.auditCompliance.operator': '操作人',
  'pages.auditCompliance.operatorPlaceholder': '请输入操作人',
  'pages.auditCompliance.moduleName': '模块名称',
  'pages.auditCompliance.moduleNamePlaceholder': '请输入模块名称',
  'pages.auditCompliance.operationType': '操作类型',
  'pages.auditCompliance.operationTime': '操作时间',
  'pages.auditCompliance.operationStatus': '操作状态',
  'pages.auditCompliance.operationDescription': '操作描述',
  'pages.auditCompliance.clientIP': '客户端IP',
  'pages.auditCompliance.operationLogList': '操作日志列表',
  'pages.auditCompliance.success': '成功',
  'pages.auditCompliance.failed': '失败',
  'pages.auditCompliance.queryFailed': '查询失败',
  'pages.auditCompliance.queryFailedRetry': '查询失败，请稍后重试',
  'pages.auditCompliance.serialNumber': '序号',
  'pages.auditCompliance.upload': '上传',
  'pages.auditCompliance.submit': '提交',
  'pages.auditCompliance.change': '变更',
  'pages.auditCompliance.config': '配置',
  'pages.auditCompliance.download': '下载',
  'pages.auditCompliance.modify': '修改',
  // DataUpload BatchAdd
  'pages.dataUpload.batchAdd.selectFileTypeFirst': '请先选择需要上传的文件类型',
  'pages.dataUpload.batchAdd.fileFormatIncorrect': '文件格式不正确！',
  'pages.dataUpload.batchAdd.fileUploadSuccess': '{fileName} 文件上传成功！',
  'pages.dataUpload.batchAdd.dataProcessSuccess': '数据处理成功！',
  'pages.dataUpload.batchAdd.dataProcessFailed': '数据处理失败！',
  'pages.dataUpload.batchAdd.processDataFailed': '处理数据失败！',
  'pages.dataUpload.batchAdd.fileUploadFailed': '{fileName} 文件上传失败！',
  'pages.dataUpload.batchAdd.uploadFailed': '{fileName} 上传失败！',
  'pages.dataUpload.batchAdd.selectFormatFirst': '请先选择格式',
  'pages.dataUpload.batchAdd.unsupportedFormat': '不支持的格式类型',
  'pages.dataUpload.batchAdd.templateDownloadSuccess': '模板下载成功',
  'pages.dataUpload.batchAdd.templateDownloadFailed': '模板下载失败',
  'pages.dataUpload.batchAdd.templateDownloadFailedRetry': '模板下载失败，请重试',
  'pages.dataUpload.batchAdd.reportBathIdRequired': '报表批次ID不能为空',
  'pages.dataUpload.batchAdd.physicalData': '物性数据',
  'pages.dataUpload.batchAdd.meltingPoint': '熔点',
  'pages.dataUpload.batchAdd.meltingPointPlaceholder': '请输入熔点',
  'pages.dataUpload.batchAdd.meltingPointRequired': '请输入熔点',
  'pages.dataUpload.batchAdd.boilingPoint': '沸点',
  'pages.dataUpload.batchAdd.boilingPointPlaceholder': '请输入沸点',
  'pages.dataUpload.batchAdd.boilingPointRequired': '请输入沸点',
  'pages.dataUpload.batchAdd.meltingEnthalpy': '熔化焓',
  'pages.dataUpload.batchAdd.meltingEnthalpyPlaceholder': '请输入熔化焓',
  'pages.dataUpload.batchAdd.surfaceTension': '表面张力',
  'pages.dataUpload.batchAdd.surfaceTensionPlaceholder': '请输入表面张力',
  'pages.dataUpload.batchAdd.contactAngle': '接触角',
  'pages.dataUpload.batchAdd.contactAnglePlaceholder': '请输入接触角',
  'pages.dataUpload.batchAdd.thermalWeightLoss': '热失重',
  'pages.dataUpload.batchAdd.thermalWeightLossPlaceholder': '请输入热失重',
  'pages.dataUpload.batchAdd.vaporPressure': '蒸汽压',
  'pages.dataUpload.batchAdd.vaporPressurePlaceholder': '请输入蒸汽压',
  'pages.dataUpload.batchAdd.chemicalData': '化学数据',
  'pages.dataUpload.batchAdd.corrosive': '腐蚀性',
  'pages.dataUpload.batchAdd.corrosivePlaceholder': '请输入腐蚀性',
  'pages.dataUpload.batchAdd.corrosiveRequired': '请输入腐蚀性',
  'pages.dataUpload.batchAdd.corrosionPotential': '腐蚀电位',
  'pages.dataUpload.batchAdd.corrosionPotentialPlaceholder': '请输入腐蚀电位',
  'pages.dataUpload.batchAdd.corrosionPotentialRequired': '请输入腐蚀电位',
  'pages.dataUpload.batchAdd.thermalStabilityWindow': '热稳定性窗口',
  'pages.dataUpload.batchAdd.thermalStabilityWindowRequired': '请填写热稳定性窗口',
  'pages.dataUpload.batchAdd.minValue': '最小值',
  'pages.dataUpload.batchAdd.minValueRequired': '请输入最小值',
  'pages.dataUpload.batchAdd.maxValue': '最大值',
  'pages.dataUpload.batchAdd.maxValueRequired': '请输入最大值',
  'pages.dataUpload.batchAdd.electrochemistryWindow': '电化学窗口',
  'pages.dataUpload.batchAdd.electrochemistryWindowRequired': '请填写电化学窗口',
  'pages.dataUpload.batchAdd.experimentCondition': '实验条件',
  'pages.dataUpload.batchAdd.sampleSize': '样品量',
  'pages.dataUpload.batchAdd.sampleSizePlaceholder': '请输入样品量',
  'pages.dataUpload.batchAdd.testDate': '测试日期',
  'pages.dataUpload.batchAdd.atmosphere': '气氛',
  'pages.dataUpload.batchAdd.atmospherePlaceholder': '请输入气氛',
  'pages.dataUpload.batchAdd.impurityConcentration': '杂质浓度',
  'pages.dataUpload.batchAdd.impurityConcentrationPlaceholder': '请输入杂质浓度',
  'pages.dataUpload.batchAdd.testPerson': '测试人',
  'pages.dataUpload.batchAdd.testPersonPlaceholder': '请输入测试人',
  'pages.dataUpload.batchAdd.testingAgency': '测试机构',
  'pages.dataUpload.batchAdd.testingAgencyPlaceholder': '请输入测试机构',
  'pages.dataUpload.batchAdd.approvalPerson': '审批人',
  'pages.dataUpload.batchAdd.approvalPersonPlaceholder': '请选择审批人',
  'pages.dataUpload.batchAdd.approvalPersonRequired': '请选择审批人',
  'pages.dataUpload.batchAdd.importData': '导入数据',
  'pages.dataUpload.batchAdd.format': '格式',
  'pages.dataUpload.batchAdd.formatPlaceholder': '请选择格式',
  'pages.dataUpload.batchAdd.formatRequired': '请选择格式',
  'pages.dataUpload.batchAdd.downloadTemplate': '下载模板',
  'pages.dataUpload.batchAdd.downloadTemplateTooltip': '点击下载对应格式的导入模板',
  'pages.dataUpload.batchAdd.selectFormatFirstTooltip': '请先选择格式',
  'pages.dataUpload.batchAdd.physicalType': '物性类型',
  'pages.dataUpload.batchAdd.physicalTypePlaceholder': '请选择物性类型',
  'pages.dataUpload.batchAdd.physicalTypeRequired': '请选择物性类型',
  'pages.dataUpload.batchAdd.component': '组分',
  'pages.dataUpload.batchAdd.componentPlaceholder': '请输入组分',
  'pages.dataUpload.batchAdd.componentRequired': '请输入组分',
  'pages.dataUpload.batchAdd.percentage': '占比',
  'pages.dataUpload.batchAdd.percentagePlaceholder': '请输入占比',
  'pages.dataUpload.batchAdd.percentageRequired': '请输入占比',
  'pages.dataUpload.batchAdd.uploadText': '点击或者拖拽文件到区域自动上传',
  'pages.dataUpload.batchAdd.uploadHint': '支持单文件上传，可多次上传单文件',
  'pages.dataUpload.batchAdd.dataPreview': '数据预览',
  'pages.dataUpload.batchAdd.submit': '确定提交',
  'pages.dataUpload.batchAdd.importTemplate': '导入模板',
  // DataImport BatchAdd
  'pages.dataImport.batchAdd.selectFileTypeFirst': '请先选择需要上传的文件类型',
  'pages.dataImport.batchAdd.fileFormatIncorrect': '文件格式不正确！',
  'pages.dataImport.batchAdd.fileUploadSuccess': '{fileName} 文件上传成功！',
  'pages.dataImport.batchAdd.dataProcessSuccess': '数据处理成功！',
  'pages.dataImport.batchAdd.dataProcessFailed': '数据处理失败！',
  'pages.dataImport.batchAdd.processDataFailed': '处理数据失败！',
  'pages.dataImport.batchAdd.fileUploadFailed': '{fileName} 文件上传失败！',
  'pages.dataImport.batchAdd.uploadFailed': '{fileName} 上传失败！',
  'pages.dataImport.batchAdd.selectFormatFirst': '请先选择格式',
  'pages.dataImport.batchAdd.unsupportedFormat': '不支持的格式类型',
  'pages.dataImport.batchAdd.templateDownloadSuccess': '模板下载成功',
  'pages.dataImport.batchAdd.templateDownloadFailed': '模板下载失败',
  'pages.dataImport.batchAdd.templateDownloadFailedRetry': '模板下载失败，请重试',
  'pages.dataImport.batchAdd.physicalData': '物性数据',
  'pages.dataImport.batchAdd.meltingPoint': '熔点',
  'pages.dataImport.batchAdd.meltingPointPlaceholder': '请输入熔点',
  'pages.dataImport.batchAdd.meltingPointRequired': '请输入熔点',
  'pages.dataImport.batchAdd.boilingPoint': '沸点',
  'pages.dataImport.batchAdd.boilingPointPlaceholder': '请输入沸点',
  'pages.dataImport.batchAdd.boilingPointRequired': '请输入沸点',
  'pages.dataImport.batchAdd.meltingEnthalpy': '熔化焓',
  'pages.dataImport.batchAdd.meltingEnthalpyPlaceholder': '请输入熔化焓',
  'pages.dataImport.batchAdd.surfaceTension': '表面张力',
  'pages.dataImport.batchAdd.surfaceTensionPlaceholder': '请输入表面张力',
  'pages.dataImport.batchAdd.contactAngle': '接触角',
  'pages.dataImport.batchAdd.contactAnglePlaceholder': '请输入接触角',
  'pages.dataImport.batchAdd.thermalWeightLoss': '热失重',
  'pages.dataImport.batchAdd.thermalWeightLossPlaceholder': '请输入热失重',
  'pages.dataImport.batchAdd.vaporPressure': '蒸汽压',
  'pages.dataImport.batchAdd.vaporPressurePlaceholder': '请输入蒸汽压',
  'pages.dataImport.batchAdd.chemicalData': '化学数据',
  'pages.dataImport.batchAdd.corrosive': '腐蚀性',
  'pages.dataImport.batchAdd.corrosivePlaceholder': '请输入腐蚀性',
  'pages.dataImport.batchAdd.corrosiveRequired': '请输入腐蚀性',
  'pages.dataImport.batchAdd.corrosionPotential': '腐蚀电位',
  'pages.dataImport.batchAdd.corrosionPotentialPlaceholder': '请输入腐蚀电位',
  'pages.dataImport.batchAdd.corrosionPotentialRequired': '请输入腐蚀电位',
  'pages.dataImport.batchAdd.thermalStabilityWindow': '热稳定性窗口',
  'pages.dataImport.batchAdd.thermalStabilityWindowRequired': '请填写热稳定性窗口',
  'pages.dataImport.batchAdd.minValue': '最小值',
  'pages.dataImport.batchAdd.minValueRequired': '请输入最小值',
  'pages.dataImport.batchAdd.maxValue': '最大值',
  'pages.dataImport.batchAdd.maxValueRequired': '请输入最大值',
  'pages.dataImport.batchAdd.electrochemistryWindow': '电化学窗口',
  'pages.dataImport.batchAdd.electrochemistryWindowRequired': '请填写电化学窗口',
  'pages.dataImport.batchAdd.experimentCondition': '实验条件',
  'pages.dataImport.batchAdd.sampleSize': '样品量',
  'pages.dataImport.batchAdd.sampleSizePlaceholder': '请输入样品量',
  'pages.dataImport.batchAdd.testDate': '测试日期',
  'pages.dataImport.batchAdd.atmosphere': '气氛',
  'pages.dataImport.batchAdd.atmospherePlaceholder': '请输入气氛',
  'pages.dataImport.batchAdd.impurityConcentration': '杂质浓度',
  'pages.dataImport.batchAdd.impurityConcentrationPlaceholder': '请输入杂质浓度',
  'pages.dataImport.batchAdd.testPerson': '测试人',
  'pages.dataImport.batchAdd.testPersonPlaceholder': '请输入测试人',
  'pages.dataImport.batchAdd.testingAgency': '测试机构',
  'pages.dataImport.batchAdd.testingAgencyPlaceholder': '请输入测试机构',
  'pages.dataImport.batchAdd.approvalPerson': '审批人',
  'pages.dataImport.batchAdd.approvalPersonPlaceholder': '请选择审批人',
  'pages.dataImport.batchAdd.approvalPersonRequired': '请选择审批人',
  'pages.dataImport.batchAdd.importData': '导入数据',
  'pages.dataImport.batchAdd.format': '格式',
  'pages.dataImport.batchAdd.formatPlaceholder': '请选择格式',
  'pages.dataImport.batchAdd.formatRequired': '请选择格式',
  'pages.dataImport.batchAdd.downloadTemplate': '下载模板',
  'pages.dataImport.batchAdd.downloadTemplateTooltip': '点击下载对应格式的导入模板',
  'pages.dataImport.batchAdd.selectFormatFirstTooltip': '请先选择格式',
  'pages.dataImport.batchAdd.physicalType': '物性类型',
  'pages.dataImport.batchAdd.physicalTypePlaceholder': '请选择物性类型',
  'pages.dataImport.batchAdd.physicalTypeRequired': '请选择物性类型',
  'pages.dataImport.batchAdd.component': '组分',
  'pages.dataImport.batchAdd.componentPlaceholder': '请输入组分',
  'pages.dataImport.batchAdd.componentRequired': '请输入组分',
  'pages.dataImport.batchAdd.percentage': '占比',
  'pages.dataImport.batchAdd.percentagePlaceholder': '请输入占比',
  'pages.dataImport.batchAdd.percentageRequired': '请输入占比',
  'pages.dataImport.batchAdd.uploadText': '点击或者拖拽文件到区域自动上传',
  'pages.dataImport.batchAdd.uploadHint': '支持单文件上传，可多次上传单文件',
  'pages.dataImport.batchAdd.dataPreview': '数据预览',
  'pages.dataImport.batchAdd.submit': '确定提交',
  'pages.dataImport.batchAdd.importTemplate': '导入模板',
  'pages.dataImport.batchAdd.excelOnly': '仅支持 Excel 格式文件上传！',
  'pages.dataImport.batchAdd.dataParseSuccess': '数据解析成功！',
  'pages.dataImport.batchAdd.dataParseFailed': '数据解析失败！',
  'pages.dataImport.batchAdd.uploadAndParseFirst': '请先上传并解析数据文件！',
  'pages.dataImport.batchAdd.updateSuccess': '修改成功',
  'pages.dataImport.batchAdd.updateFailed': '修改失败',
  'pages.dataImport.batchAdd.submitSuccess': '提交成功',
  'pages.dataImport.batchAdd.submitFailed': '提交失败',
  'pages.dataImport.batchAdd.machineLearningParams': '机器学习参数',
  'pages.dataImport.batchAdd.simulationAlgorithm': '仿真算法',
  'pages.dataImport.batchAdd.simulationAlgorithmPlaceholder': '请选择仿真算法',
  'pages.dataImport.batchAdd.simulationAlgorithmRequired': '请选择仿真算法',
  'pages.dataImport.batchAdd.simulationTemplateName': '仿真计算结果批量导入模板.xlsx',
  // DataImport MidDataImport
  'pages.dataImport.midDataImport.system': '体系',
  'pages.dataImport.midDataImport.systemPlaceholder': '请输入体系',
  'pages.dataImport.midDataImport.mol': 'MOL',
  'pages.dataImport.midDataImport.molPlaceholder': '请输入MOL',
  'pages.dataImport.midDataImport.temp': '温度',
  'pages.dataImport.midDataImport.tempPlaceholder': '请输入温度',
  'pages.dataImport.midDataImport.physicalType': '物性类型',
  'pages.dataImport.midDataImport.physicalTypePlaceholder': '请选择物性类型',
  'pages.dataImport.midDataImport.fileUploadSuccess': '{fileName} 文件上传成功！',
  'pages.dataImport.midDataImport.fileUploadFailed': '{fileName} 文件上传失败！',
  'pages.dataImport.midDataImport.uploadFailed': '{fileName} 上传失败！',
  'pages.dataImport.midDataImport.uploadFileFirst': '请先上传文件！',
  // Project Experience
  'pages.projectExperience.projectDetailedReport': '项目详细报告',
  'pages.projectExperience.chartPlaceholder': '图表占位符 - 数据正在加载中...',
  'pages.projectExperience.projectOverview': '项目概述',
  'pages.projectExperience.technicalFeatures': '技术特点',
  'pages.projectExperience.problemAnalysis': '问题分析',
  'pages.projectExperience.solutions': '解决方案',
  'pages.projectExperience.implementationEffects': '实施效果',
  'pages.projectExperience.achievementsExperience': '成果与经验',
  'pages.projectExperience.projectDetails': '项目详情',
  // Experiment Integration
  'pages.experiment.experimentData': '实验数据',
  'pages.experiment.experimentFlow': '实验流程',
  'pages.experiment.experimentReport': '实验报告',
  'pages.experiment.experimentNo': '实验编号',
  'pages.experiment.experimentName': '实验名称',
  'pages.experiment.materialSystem': '材料体系',
  'pages.experiment.physicalPropertyType': '物性类型',
  'pages.experiment.physicalPropertyValue': '物性数值',
  'pages.experiment.temperature': '温度',
  'pages.experiment.experimentStatus': '实验状态',
  'pages.experiment.syncTime': '同步时间',
  'pages.experiment.syncStatus': '同步状态',
  'pages.experiment.syncSuccess': '成功',
  'pages.experiment.syncFailed': '失败',
  'pages.experiment.flowStep': '流程步骤',
  'pages.experiment.stepStatus': '步骤状态',
  'pages.experiment.startTime': '开始时间',
  'pages.experiment.endTime': '完成时间',
  'pages.experiment.operator': '操作人',
  'pages.experiment.taskNo': '任务编号',
  'pages.experiment.taskName': '任务名称',
  'pages.experiment.simulationType': '仿真类型',
  'pages.experiment.taskStatus': '任务状态',
  'pages.experiment.submitTime': '提交时间',
  'pages.experiment.submitter': '提交人',
  'pages.experiment.operation': '操作',
  'pages.experiment.viewDetails': '查看详情',
  'pages.experiment.viewStatus': '查看状态',
  'pages.experiment.statusCompleted': '已完成',
  'pages.experiment.statusInProgress': '进行中',
  'pages.experiment.statusRunning': '计算中',
  'pages.experiment.statusSubmitted': '已提交',
  'pages.experiment.statusPending': '待提交',
  'pages.experiment.statusPendingStart': '待开始',
  'pages.experiment.statusCancelled': '已取消',
  'pages.experiment.statusNotStarted': '未开始',
  'pages.experiment.statusFailed': '失败',
  // Task Experiment Calculate Details
  'pages.experimentCalculate.workflowADetail': '工作流A: 实验验证型详情',
  'pages.experimentCalculate.workflowAOverview': '实验验证型工作流程',
  'pages.experimentCalculate.workflowADescription': '通过实验数据验证计算模型的准确性，并生成验证报告',
  'pages.experimentCalculate.inputData': '输入数据',
  'pages.experimentCalculate.outputResults': '输出结果',
  'pages.experimentCalculate.workflowSteps': '工作流程步骤',
  'pages.experimentCalculate.viscosityData': '实验粘度数据 (η-T)',
  'pages.experimentCalculate.referenceData': '参考数据库数据',
  'pages.experimentCalculate.calculationResults': '计算模拟结果',
  'pages.experimentCalculate.consistencyAnalysis': '数据一致性分析',
  'pages.experimentCalculate.accuracyAssessment': '模型准确性评估',
  'pages.experimentCalculate.verificationReport': '验证报告',
  'pages.experimentCalculate.dataCleaning': '数据清洗',
  'pages.experimentCalculate.dataCleaningDesc': '处理异常值、缺失值和格式问题',
  'pages.experimentCalculate.arrheniusFitting': 'Arrhenius拟合',
  'pages.experimentCalculate.arrheniusFittingDesc': '对粘度-温度关系进行拟合',
  'pages.experimentCalculate.dataComparison': '数据对比',
  'pages.experimentCalculate.dataComparisonDesc': '与数据库和仿真结果进行对比分析',
  'pages.experimentCalculate.generateReport': '生成报告',
  'pages.experimentCalculate.generateReportDesc': '自动生成验证报告，包含一致性评估',
  'pages.experimentCalculate.viscosityWorkflowTitle': '粘度数据驱动工作流详情',
  'pages.experimentCalculate.viscosityWorkflowDesc': '利用实验粘度数据驱动分子动力学(MD)模拟，验证并补充其他物性参数。',
  'pages.experimentCalculate.consistencyAnalysisTitle': '数据-致性分析',
  'pages.experimentCalculate.experimentalVerificationWorkflow': '实验验证型工作流程',
  'pages.experimentCalculate.experimentalVerificationWorkflowDesc': '通过实验数据验证计算模型的准确性，并生成验证报告',
  'pages.experimentCalculate.startThisWorkflow': '启动此工作流',
  'pages.experimentCalculate.workflowA': '工作流A: 实验验证型',
  'pages.experimentCalculate.workflowB': '工作流B: 性能优化型',
  'pages.experimentCalculate.workflowC': '工作流C: 腐蚀评估型',
  'pages.experimentCalculate.input': '输入',
  'pages.experimentCalculate.output': '输出',
  'pages.experimentCalculate.systemProcess': '系统流程',
  'pages.experimentCalculate.workflowAProcess': '数据清洗 → Arrhenius拟合 → 与数据库/仿真对比 → 自动生成验证报告',
  'pages.experimentCalculate.workflowBProcess': '调用数据库 → ML预测候选配方 → 生成推荐盐体系',
  'pages.experimentCalculate.workflowCProcess': '调用电化学/腐蚀模型 → 预测Ni/Cr溶解速率 → 生成材料兼容性报告',
  'pages.experimentCalculate.autoGenerateReport': '自动生成验证报告',
  'pages.experimentCalculate.targetPerformance': '目标性能 Cp≥2J/g·K',
  'pages.experimentCalculate.recommendedSaltSystem': '推荐盐体系',
  'pages.experimentCalculate.saltComponentImpurityLevel': '盐成分 + 杂质水平',
  'pages.experimentCalculate.materialCompatibilityReport': '材料兼容性报告',
  'pages.experimentCalculate.workflowBDetail': '工作流B: 性能优化型详情',
  'pages.experimentCalculate.workflowCDetail': '工作流C: 腐蚀评估型详情',
  'pages.experimentCalculate.workflowB.title': '性能优化型工作流程',
  'pages.experimentCalculate.workflowB.description': '基于目标性能要求,通过机器学习预测并推荐最优材料配方。',
  'pages.experimentCalculate.workflowB.input1': '目标性能指标 (Cp≥2J/g·K, η≤3mPa·s)',
  'pages.experimentCalculate.workflowB.input2': '材料成分数据库',
  'pages.experimentCalculate.workflowB.input3': '历史性能数据',
  'pages.experimentCalculate.workflowB.output1': '候选材料推荐',
  'pages.experimentCalculate.workflowB.output2': '性能预测结果',
  'pages.experimentCalculate.workflowB.output3': '优化建议报告',
  'pages.experimentCalculate.workflowB.step1': '需求分析',
  'pages.experimentCalculate.workflowB.step1Desc': '解析目标性能要求',
  'pages.experimentCalculate.workflowB.step2': '数据筛选',
  'pages.experimentCalculate.workflowB.step2Desc': '从数据库筛选符合条件的候选材料',
  'pages.experimentCalculate.workflowB.step3': '机器学习预测',
  'pages.experimentCalculate.workflowB.step3Desc': '使用训练好的模型预测候选材料性能',
  'pages.experimentCalculate.workflowB.step4': '结果排序',
  'pages.experimentCalculate.workflowB.step4Desc': '根据预测结果对候选材料进行排序',
  'pages.experimentCalculate.workflowB.step5': '生成推荐',
  'pages.experimentCalculate.workflowB.step5Desc': '输出最优材料配方及性能预测',
  'pages.experimentCalculate.workflowC.title': '腐蚀评估型工作流程',
  'pages.experimentCalculate.workflowC.description': '评估熔盐对结构材料的腐蚀性,生成材料兼容性报告。',
  'pages.experimentCalculate.workflowC.input1': '盐成分与杂质水平',
  'pages.experimentCalculate.workflowC.input2': '结构材料信息',
  'pages.experimentCalculate.workflowC.input3': '操作条件(温度、时间)',
  'pages.experimentCalculate.workflowC.output1': '腐蚀速率预测',
  'pages.experimentCalculate.workflowC.output2': '材料兼容性评估',
  'pages.experimentCalculate.workflowC.output3': '防护措施建议',
  'pages.experimentCalculate.workflowC.step1': '参数输入',
  'pages.experimentCalculate.workflowC.step1Desc': '输入盐成分、杂质和材料信息',
  'pages.experimentCalculate.workflowC.step2': '模型计算',
  'pages.experimentCalculate.workflowC.step2Desc': '调用电化学/腐蚀模型计算腐蚀速率',
  'pages.experimentCalculate.workflowC.step3': '风险评估',
  'pages.experimentCalculate.workflowC.step3Desc': '基于计算结果评估材料兼容性',
  'pages.experimentCalculate.workflowC.step4': '生成报告',
  'pages.experimentCalculate.workflowC.step4Desc': '输出详细的腐蚀评估报告',
  // Experiment Calculate Steps
  'pages.experimentCalculate.step1.title': '步骤1: 实验数据',
  'pages.experimentCalculate.step1.subtitle': '实验数据采集与预处理',
  'pages.experimentCalculate.step1.description': '从多种实验仪器中采集熔盐物性数据，并进行标准化预处理，确保数据质量和一致性。',
  'pages.experimentCalculate.step1.supportedDataTypes': '支持的实验数据类型',
  'pages.experimentCalculate.step1.dataProcessingFlow': '数据处理流程',
  'pages.experimentCalculate.step1.processingStep1': '数据采集',
  'pages.experimentCalculate.step1.processingDesc1': '从实验仪器获取原始数据',
  'pages.experimentCalculate.step1.processingStep2': '数据清洗',
  'pages.experimentCalculate.step1.processingDesc2': '去除异常值和噪声',
  'pages.experimentCalculate.step1.processingStep3': '格式标准化',
  'pages.experimentCalculate.step1.processingDesc3': '统一数据格式和单位',
  'pages.experimentCalculate.step1.processingStep4': '数据验证',
  'pages.experimentCalculate.step1.processingDesc4': '检查数据完整性和准确性',
  'pages.experimentCalculate.step1.viscosityData': '粘度数据',
  'pages.experimentCalculate.step1.viscosityRelation': 'η-T关系',
  'pages.experimentCalculate.step1.densityData': '密度数据',
  'pages.experimentCalculate.step1.densityRelation': 'ρ-T关系',
  'pages.experimentCalculate.step1.specificHeatData': '比热数据',
  'pages.experimentCalculate.step1.specificHeatRelation': 'Cp-T关系',
  'pages.experimentCalculate.step1.thermalConductivityData': '热导率数据',
  'pages.experimentCalculate.step1.thermalConductivityRelation': 'λ-T关系',
  'pages.experimentCalculate.step1.electricalConductivityData': '电导率数据',
  'pages.experimentCalculate.step1.electricalConductivityRelation': 'σ-T关系',
  'pages.experimentCalculate.step2.title': '步骤2: 仿真计算',
  'pages.experimentCalculate.step2.subtitle': '多尺度仿真计算',
  'pages.experimentCalculate.step2.description': '采用多种计算方法，从原子尺度到宏观尺度，全面模拟和预测熔盐的物性行为。',
  'pages.experimentCalculate.step2.supportedTools': '支持的工具：',
  'pages.experimentCalculate.step2.mdTitle': '分子动力学(MD)',
  'pages.experimentCalculate.step2.mdDesc': '模拟熔盐微观结构与输运性质',
  'pages.experimentCalculate.step2.dftTitle': '密度泛函理论(DFT)',
  'pages.experimentCalculate.step2.dftDesc': '计算电子结构与热力学性质',
  'pages.experimentCalculate.step2.calphadTitle': 'CALPHAD方法',
  'pages.experimentCalculate.step2.calphadDesc': '计算相图与热力学性质',
  'pages.experimentCalculate.step2.toolLammps': 'LAMMPS',
  'pages.experimentCalculate.step2.toolGromacs': 'GROMACS',
  'pages.experimentCalculate.step2.toolCustom': '自定义力场',
  'pages.experimentCalculate.step2.toolVasp': 'VASP',
  'pages.experimentCalculate.step2.toolQe': 'Quantum ESPRESSO',
  'pages.experimentCalculate.step2.toolCastep': 'CASTEP',
  'pages.experimentCalculate.step2.toolThermoCalc': 'Thermo-Calc',
  'pages.experimentCalculate.step2.toolFactSage': 'FactSage',
  'pages.experimentCalculate.step2.toolPandat': 'Pandat',
  'pages.experimentCalculate.step3.title': '步骤3: 验证优化',
  'pages.experimentCalculate.step3.subtitle': '数据验证与模型优化',
  'pages.experimentCalculate.step3.description': '对比实验数据与仿真结果，通过系统化的分析和优化流程，提升计算模型的准确性和可靠性。',
  'pages.experimentCalculate.step4.title': '步骤4: 性能预测',
  'pages.experimentCalculate.step4.subtitle': '新材料性能预测与优化',
  'pages.experimentCalculate.step4.description': '基于验证后的模型预测新材料性能，通过智能优化算法进行材料设计，加速新材料开发进程。',
  'pages.experimentCalculate.step4.coreFeatures': '核心功能：',
  'pages.experimentCalculate.step4.dataComparisonAnalysis': '数据对比分析',
  'pages.experimentCalculate.step4.dataComparisonDesc': '实验数据与仿真结果的对比分析',
  'pages.experimentCalculate.step4.modelOptimization': '模型参数优化',
  'pages.experimentCalculate.step4.modelOptimizationDesc': '基于实验数据优化仿真模型参数',
  'pages.experimentCalculate.step4.reportGeneration': '验证报告生成',
  'pages.experimentCalculate.step4.reportGenerationDesc': '生成详细的验证报告',
  'pages.experimentCalculate.step4.feature1': '误差分析',
  'pages.experimentCalculate.step4.feature2': '一致性评估',
  'pages.experimentCalculate.step4.feature3': '趋势验证',
  'pages.experimentCalculate.step4.feature4': '敏感性分析',
  'pages.experimentCalculate.step4.feature5': '参数调优',
  'pages.experimentCalculate.step4.feature6': '模型验证',
  'pages.experimentCalculate.step4.feature7': '数据对比图表',
  'pages.experimentCalculate.step4.feature8': '模型准确性评估',
  'pages.experimentCalculate.step4.feature9': '优化建议',
  'pages.experimentCalculate.step5.performancePrediction': '性能预测',
  'pages.experimentCalculate.step5.performancePredictionDesc': '基于验证模型预测新材料性能',
  'pages.experimentCalculate.step5.optimizationDesign': '优化设计',
  'pages.experimentCalculate.step5.optimizationDesignDesc': '基于目标性能优化材料设计',
  'pages.experimentCalculate.step5.designReport': '设计报告',
  'pages.experimentCalculate.step5.designReportDesc': '生成新材料设计报告',
  'pages.experimentCalculate.step5.feature1': '物性预测',
  'pages.experimentCalculate.step5.feature2': '性能评估',
  'pages.experimentCalculate.step5.feature3': '趋势分析',
  'pages.experimentCalculate.step5.feature4': '多目标优化',
  'pages.experimentCalculate.step5.feature5': '约束条件处理',
  'pages.experimentCalculate.step5.feature6': '最优解搜索',
  'pages.experimentCalculate.step5.feature7': '性能预测结果',
  'pages.experimentCalculate.step5.feature8': '优化设计方案',
  'pages.experimentCalculate.step5.feature9': '实施建议',
  // Result Download
  'pages.resultDownload.workflowDetail': '工作流详情',
  'pages.resultDownload.basicInfo': '基本信息',
  'pages.resultDownload.workflowNo': '工作流编号',
  'pages.resultDownload.workflowName': '工作流名称',
  'pages.resultDownload.createTime': '创建时间',
  'pages.resultDownload.workflowType': '工作流类型',
  'pages.resultDownload.workflowStatus': '工作流状态',
  'pages.resultDownload.priority': '优先级',
  'pages.resultDownload.creator': '创建人',
  'pages.resultDownload.workflowDesc': '工作流描述',
  'pages.resultDownload.progressInfo': '进度信息',
  'pages.resultDownload.queuePosition': '队列位置',
  'pages.resultDownload.startTime': '开始执行时间',
  'pages.resultDownload.endTime': '结束时间',
  'pages.resultDownload.executionDuration': '执行时长',
  'pages.resultDownload.actualDuration': '实际',
  'pages.resultDownload.estimatedDuration': '预计',
  'pages.resultDownload.getDetailFailed': '获取详情失败',
  'pages.resultDownload.priorityNormal': '普通',
  'pages.resultDownload.priorityHigh': '高',
  'pages.resultDownload.priorityUrgent': '紧急',
  'pages.resultDownload.uploadSuccess': '{fileName} 上传成功！',
  'pages.resultDownload.uploadFailed': '{fileName} 上传失败！',
  'pages.resultDownload.startWorkflowSuccess': '工作流启动成功',
  'pages.dataImport.midDataImport.importSuccess': '中间数据导入成功！',
  'pages.dataImport.midDataImport.importFailed': '中间数据导入失败！',
  'pages.dataImport.midDataImport.molRequired': '请输入摩尔比',
  'pages.dataImport.midDataImport.tempRequired': '请输入温度',
  'pages.dataImport.midDataImport.systemRequired': '请输入体系',
  'pages.dataImport.midDataImport.physicalTypeRequired': '请选择物性类型',
  'pages.dataImport.midDataImport.midData': '中间数据',
  'pages.dataImport.midDataImport.fileUploaded': '文件已上传',
  'pages.dataImport.midDataImport.pleaseUploadFile': '请上传文件',
  'pages.dataImport.midDataImport.uploadText': '点击或者拖拽文件到区域自动上传',
  'pages.dataImport.midDataImport.uploadHint': '支持单文件上传',
  'pages.dataImport.midDataImport.confirm': '确定',
  // DataImport Add
  'pages.dataImport.add.simulateBathIdRequired': '仿真批次ID不能为空',
  'pages.dataImport.add.atLeastOneCoefficient': '请至少填写一个系数',
  'pages.dataImport.add.tmaxRequired': '请填写Tmax',
  'pages.dataImport.add.batchDataRequired': '请至少填写批次相关数据',
  'pages.dataImport.add.submitting': '数据提交中，请稍候...',
  'pages.dataImport.add.submitSuccess': '提交成功',
  'pages.dataImport.add.submitFailed': '提交失败，请重试',
  'pages.dataImport.add.submit': '确定提交',
  'pages.dataImport.add.materialData': '材料数据',
  'pages.dataImport.add.component': '组分',
  'pages.dataImport.add.componentPlaceholder': '请输入组分',
  'pages.dataImport.add.componentRequired': '请输入组分',
  'pages.dataImport.add.percentage': '占比',
  'pages.dataImport.add.percentagePlaceholder': '请输入占比',
  'pages.dataImport.add.percentageRequired': '请输入占比',
  'pages.dataImport.add.physicalType': '物性类型',
  'pages.dataImport.add.physicalTypePlaceholder': '请选择物性类型',
  'pages.dataImport.add.physicalTypeRequired': '请选择物性类型',
  'pages.dataImport.add.physicalUnit': '物性单位',
  'pages.dataImport.add.physicalUnitRequired': '请选择物性单位',
  'pages.dataImport.add.selectPhysicalTypeFirst': '请先选择物性类型',
  'pages.dataImport.add.dataSource': '数据来源',
  'pages.dataImport.add.dataSourcePlaceholder': '请输入数据来源',
  'pages.dataImport.add.dataSourceRequired': '请输入数据来源',
  'pages.dataImport.add.tTminPlaceholder': '请输入T/Tmin',
  'pages.dataImport.add.tTminRequired': '请输入T/Tmin',
  'pages.dataImport.add.tmaxPlaceholder': '请输入Tmax',
  'pages.dataImport.add.tempUnit': '温度单位',
  'pages.dataImport.add.tempUnitPlaceholder': '请选择温度单位',
  'pages.dataImport.add.tempUnitRequired': '请选择温度单位',
  'pages.dataImport.add.coefficientA': '系数a',
  'pages.dataImport.add.coefficientAPlaceholder': '请输入系数a',
  'pages.dataImport.add.coefficientB': '系数b',
  'pages.dataImport.add.coefficientBPlaceholder': '请输入系数b',
  'pages.dataImport.add.coefficientC': '系数c',
  'pages.dataImport.add.coefficientCPlaceholder': '请输入系数c',
  'pages.dataImport.add.coefficientD': '系数d',
  'pages.dataImport.add.coefficientDPlaceholder': '请输入系数d',
  'pages.dataImport.add.coefficientE': '系数e',
  'pages.dataImport.add.coefficientEPlaceholder': '请输入系数e',
  'pages.dataImport.add.physicalData': '物性数据',
  'pages.dataImport.add.meltingPoint': '熔点',
  'pages.dataImport.add.meltingPointPlaceholder': '请输入熔点',
  'pages.dataImport.add.boilingPoint': '沸点',
  'pages.dataImport.add.boilingPointPlaceholder': '请输入沸点',
  'pages.dataImport.add.meltingEnthalpy': '熔化焓',
  'pages.dataImport.add.meltingEnthalpyPlaceholder': '请输入熔化焓',
  'pages.dataImport.add.surfaceTension': '表面张力',
  'pages.dataImport.add.surfaceTensionPlaceholder': '请输入表面张力',
  'pages.dataImport.add.contactAngle': '接触角',
  'pages.dataImport.add.contactAnglePlaceholder': '请输入接触角',
  'pages.dataImport.add.thermalWeightLoss': '热失重',
  'pages.dataImport.add.thermalWeightLossPlaceholder': '请输入热失重',
  'pages.dataImport.add.vaporPressure': '蒸汽压',
  'pages.dataImport.add.vaporPressurePlaceholder': '请输入蒸汽压',
  'pages.dataImport.add.chemicalData': '化学数据',
  'pages.dataImport.add.corrosive': '腐蚀性',
  'pages.dataImport.add.corrosivePlaceholder': '请输入腐蚀性',
  'pages.dataImport.add.corrosiveRequired': '请输入腐蚀性',
  'pages.dataImport.add.corrosionPotential': '腐蚀电位',
  'pages.dataImport.add.corrosionPotentialPlaceholder': '请输入腐蚀电位',
  'pages.dataImport.add.corrosionPotentialRequired': '请输入腐蚀电位',
  'pages.dataImport.add.thermalStabilityWindow': '热稳定性窗口',
  'pages.dataImport.add.thermalStabilityWindowRequired': '请填写热稳定性窗口',
  'pages.dataImport.add.minValue': '最小值',
  'pages.dataImport.add.minValueRequired': '请输入最小值',
  'pages.dataImport.add.maxValue': '最大值',
  'pages.dataImport.add.maxValueRequired': '请输入最大值',
  'pages.dataImport.add.electrochemistryWindow': '电化学窗口',
  'pages.dataImport.add.electrochemistryWindowRequired': '请填写电化学窗口',
  'pages.dataImport.add.experimentCondition': '实验条件',
  'pages.dataImport.add.sampleSize': '样品量',
  'pages.dataImport.add.sampleSizePlaceholder': '请输入样品量',
  'pages.dataImport.add.testDate': '测试日期',
  'pages.dataImport.add.atmosphere': '气氛',
  'pages.dataImport.add.atmospherePlaceholder': '请输入气氛',
  'pages.dataImport.add.impurityConcentration': '杂质浓度',
  'pages.dataImport.add.impurityConcentrationPlaceholder': '请输入杂质浓度',
  'pages.dataImport.add.testPerson': '测试人',
  'pages.dataImport.add.testPersonPlaceholder': '请输入测试人',
  'pages.dataImport.add.testingAgency': '测试机构',
  'pages.dataImport.add.testingAgencyPlaceholder': '请输入测试机构',
  'pages.dataImport.add.approvalPerson': '审批人',
  'pages.dataImport.add.approvalPersonPlaceholder': '请选择审批人',
  'pages.dataImport.add.approvalPersonRequired': '请选择审批人',
  'pages.dataImport.add.machineLearningParams': '机器学习参数',
  'pages.dataImport.add.simulationAlgorithm': '仿真算法',
  'pages.dataImport.add.simulationAlgorithmPlaceholder': '请选择仿真算法',
  'pages.dataImport.add.simulationAlgorithmRequired': '请选择仿真算法',
  'pages.dataImport.add.potentialFunc': '趋势函数类型',
  'pages.dataImport.add.potentialFuncPlaceholder': '请输入趋势函数类型',
  'pages.dataImport.add.boxStepLength': '模拟盒步长',
  'pages.dataImport.add.boxStepLengthPlaceholder': '请输入模拟盒步长',
  'pages.dataImport.add.boxSize': '模拟盒尺寸',
  'pages.dataImport.add.boxSizePlaceholder': '请输入模拟盒尺寸',
  'pages.dataImport.add.importData': '导入数据',
  // FaultDetection EditTaskModal
  'pages.faultDetection.getTaskDetailFailed': '获取任务详情失败',
  'pages.faultDetection.getTaskDetailFailedRetry': '获取任务详情失败，请重试',
  'pages.faultDetection.taskIdNotFoundUpdate': '任务ID不存在，无法更新',
  'pages.faultDetection.detectionParamsFormatError': '检测参数格式错误，请输入有效的JSON格式',
  'pages.faultDetection.updateSuccess': '更新任务成功',
  'pages.faultDetection.updateFailed': '更新任务失败',
  'pages.faultDetection.updateFailedRetry': '更新任务失败，请重试',
  'pages.faultDetection.selectDetectionMethodFirst': '请先选择检测方法',
  'pages.faultDetection.zScoreParamsExample': 'Z-score方法阈值,默认3.0。例如:{"threshold": 3.0}',
  'pages.faultDetection.iqrParamsExample': 'IQR方法倍数,默认1.5。例如:{"multiplier": 1.5}',
  'pages.faultDetection.autoencoderParamsExample': 'Autoencoder阈值,默认0.5。例如:{"threshold": 0.5}',
  'pages.faultDetection.inputJsonFormatParams': '请输入JSON格式的检测参数',
  'pages.faultDetection.editTaskModalTitle': '修改异常检测任务',
  'pages.faultDetection.taskNamePlaceholder': '请输入任务名称',
  'pages.faultDetection.dataSourcePlaceholder': '请选择数据来源',
  'pages.faultDetection.detectionMethodPlaceholder': '请选择检测方法',
  'pages.faultDetection.detectionParamsLabel': '检测参数（JSON格式）',
  'pages.faultDetection.detectionParamsPlaceholder': '请输入JSON格式的检测参数，例如: {"threshold": 0.5}',
  'pages.faultDetection.physicalTypePlaceholder': '请选择物性类型（可选）',
  'pages.faultDetection.update': '更新',
  // FaultDetection CreateTaskModal
  'pages.faultDetection.createSuccess': '创建任务成功',
  'pages.faultDetection.createFailed': '创建任务失败',
  'pages.faultDetection.createFailedRetry': '创建任务失败，请重试',
  'pages.faultDetection.createTaskModalTitle': '新建异常检测任务',
  'pages.faultDetection.taskNameExtra': '可选，不填写则自动生成',
  'pages.faultDetection.dataSourceRequired': '请选择数据来源',
  'pages.faultDetection.detectionMethodRequired': '请选择检测方法',
  'pages.faultDetection.physicalUnit': '物性单位',
  'pages.faultDetection.selectPhysicalTypeFirst': '请先选择物性类型',
  'pages.faultDetection.physicalUnitPlaceholder': '请选择物性单位（可选）',
  'pages.faultDetection.tempUnit': '温度单位',
  'pages.faultDetection.tempUnitPlaceholder': '请选择温度单位（可选）',
  'pages.faultDetection.filterCondition': '筛选条件',
  'pages.faultDetection.filterConditionExtra': '可选，例如：LiF-BeF2',
  'pages.faultDetection.filterConditionPlaceholder': '请输入筛选条件（可选）',
  'pages.faultDetection.recordIdsLabel': '数据记录ID列表',
  'pages.faultDetection.recordIdsExtra': '可选，多个ID请用逗号分隔，例如：1,2,3。不填写则检测所有数据',
  'pages.faultDetection.recordIdsPlaceholder': '请输入数据记录ID，多个ID用逗号分隔（可选）',
  'pages.faultDetection.submit': '提交',
  // FaultDetection main page
  'pages.faultDetection.title': '异常检测任务列表',
  'pages.faultDetection.taskName': '任务名称',
  'pages.faultDetection.dataSource': '数据来源',
  'pages.faultDetection.detectionMethod': '检测方法',
  'pages.faultDetection.taskStatus': '任务状态',
  'pages.faultDetection.physicalType': '物性类型',
  'pages.faultDetection.totalRecords': '总记录数',
  'pages.faultDetection.anomalyCount': '异常数量',
  'pages.faultDetection.createTime': '创建时间',
  'pages.faultDetection.operation': '操作',
  'pages.faultDetection.all': '全部',
  'pages.faultDetection.taskId': '任务ID',
  'pages.faultDetection.detail': '详情',
  'pages.faultDetection.edit': '修改',
  'pages.faultDetection.delete': '删除',
  'pages.faultDetection.add': '新增',
  'pages.faultDetection.total': '共 {total} 条',
  'pages.faultDetection.taskIdNotFound': '任务ID不存在，无法查看详情',
  'pages.faultDetection.taskIdNotFoundEdit': '任务ID不存在，无法修改',
  'pages.faultDetection.taskIdNotFoundDelete': '任务ID不存在，无法删除',
  'pages.faultDetection.deleteSuccess': '删除成功',
  'pages.faultDetection.deleteFailure': '删除失败',
  'pages.faultDetection.deleteConfirm': '确定要删除这个任务吗？',
  'pages.faultDetection.confirm': '确定',
  'pages.faultDetection.cancel': '取消',
  // DetailsModal additional translations
  'pages.faultDetection.taskDetails': '任务信息',
  'pages.faultDetection.taskInfo': '任务信息',
  'pages.faultDetection.finishTime': '完成时间',
  'pages.faultDetection.detectionStatistics': '检测统计',
  'pages.faultDetection.normalCount': '正常数量',
  'pages.faultDetection.anomalyRate': '异常率',
  'pages.faultDetection.averageAnomalyScore': '平均异常分数',
  'pages.faultDetection.anomalyDetectionResults': '异常检测结果',
  'pages.faultDetection.unknownType': '未知类型',
  'pages.faultDetection.notReviewed': '未复核',
  'pages.faultDetection.recordId': '记录ID',
  'pages.faultDetection.anomalyReason': '异常原因',
  'pages.faultDetection.anomalyStatus': '异常状态',
  'pages.faultDetection.detectionDetails': '检测详情',
  'pages.faultDetection.noAnomalyResults': '暂无异常检测结果',
  'pages.faultDetection.anomalyType': '异常类型',
  'pages.faultDetection.reviewAction': '复核操作',
  'pages.faultDetection.reviewCommentOptional': '复核意见（可选）',
  'pages.faultDetection.enterReviewComment': '请输入复核意见',
  'pages.faultDetection.selectReviewAction': '请选择复核操作',
  'pages.faultDetection.reviewSubmitted': '复核提交成功',
  'pages.faultDetection.reviewSubmitFailed': '复核提交失败',
  'pages.faultDetection.reviewSubmitFailedRetry': '提交复核失败，请重试',
  'pages.faultDetection.getDataFailed': '获取数据失败，请重试',
  // Performance Prediction
  'pages.performancePrediction.predictionResults': '预测结果',
  'pages.performancePrediction.saltSystem': '盐体系',
  'pages.performancePrediction.temperatureRange': '温度范围',
  'pages.performancePrediction.algorithmType': '算法类型',
  'pages.performancePrediction.dataSource': '数据来源',
  'pages.performancePrediction.exampleData': '示例数据',
  'pages.performancePrediction.showJsonData': '显示 JSON数据',
  'pages.performancePrediction.hideJsonData': '隐藏 JSON数据',
  'pages.performancePrediction.copy': '复制',
  'pages.performancePrediction.noPropertyResults': '暂无物性结果数据',
  'pages.performancePrediction.fittingEquation': '拟合方程',
  'pages.performancePrediction.fittingPoints': '拟合点数',
  'pages.performancePrediction.fittingPointData': '拟合点数据',
  'pages.performancePrediction.fittingCurve': '拟合曲线图',
  'pages.performancePrediction.propertyDescription': '物性说明',
  'pages.performancePrediction.suggestions': '相关建议',
  // Properties Grouper
  'pages.propertiesGrouper.screeningResults': '筛选结果',
  'pages.propertiesGrouper.saltSystemComposition': '盐体系成分',
  'pages.propertiesGrouper.analysisType': '分析类型',
  'pages.propertiesGrouper.analysisMethod': '分析方法',
  'pages.propertiesGrouper.classificationResult': '分类结果',
  'pages.propertiesGrouper.clusteringResult': '聚类结果',
  'pages.propertiesGrouper.stabilityLevel': '稳定性等级',
  'pages.propertiesGrouper.corrosionLevel': '腐蚀性等级',
  'pages.propertiesGrouper.confidenceScore': '置信度分数',
  'pages.propertiesGrouper.suggestions': '相关建议',
  'pages.propertiesGrouper.classificationDetails': '分类详情',
  'pages.propertiesGrouper.clusterDescription': '聚类描述',
  'pages.propertiesGrouper.similarityScore': '相似度分数',
  'pages.propertiesGrouper.clusterMembers': '聚类成员',
  'pages.propertiesGrouper.clusterCenter': '聚类中心',
  'pages.propertiesGrouper.commonPatterns': '共性规律',
  'pages.propertiesGrouper.unnamedCluster': '未命名',
  // Version Manager
  'pages.versionManager.editModel': '编辑模型',
  'pages.versionManager.deployModel': '部署模型',
  'pages.versionManager.versionNumber': '版本号',
  'pages.versionManager.versionNumberPlaceholder': '请输入版本号',
  'pages.versionManager.versionNumberRequired': '请输入版本号',
  'pages.versionManager.algorithmList': '算法列表',
  'pages.versionManager.selectAlgorithm': '请选择算法',
  'pages.versionManager.algorithmRequired': '请选择算法',
  'pages.versionManager.protocolList': '协议列表',
  'pages.versionManager.selectProtocol': '请选择协议',
  'pages.versionManager.protocolRequired': '请选择协议',
  'pages.versionManager.modelAddress': '模型地址',
  'pages.versionManager.modelAddressPlaceholder': '请输入模型地址',
  'pages.versionManager.modelAddressRequired': '请输入模型地址',
  'pages.versionManager.requestType': '请求方式',
  'pages.versionManager.selectRequestType': '请选择请求方式',
  'pages.versionManager.requestTypeRequired': '请选择请求方式',
  'pages.versionManager.modelFile': '模型文件',
  'pages.versionManager.uploadModelFile': '请上传模型文件',
  'pages.versionManager.modelFileRequired': '请上传模型文件',
  'pages.versionManager.selectFile': '选择文件',
  'pages.versionManager.inputParams': '输入参数',
  'pages.versionManager.selectParamName': '请选择参数名称',
  'pages.versionManager.paramNameRequired': '请选择参数名称',
  'pages.versionManager.inputParamKey': '请输入参数KEY',
  'pages.versionManager.paramKeyRequired': '请输入参数KEY',
  'pages.versionManager.addInputParam': '添加输入参数',
  'pages.versionManager.outputParams': '输出参数',
  'pages.versionManager.selectOutputParams': '请选择输出参数',
  'pages.versionManager.outputParamsRequired': '请选择输出参数',
  'pages.versionManager.outputParamsCombo': '输出参数组合',
  'pages.versionManager.addOutputParam': '添加输出参数',
  'pages.versionManager.defaultVersion': '默认版本',
  'pages.versionManager.selectDefaultVersion': '请选择默认版本',
  'pages.versionManager.defaultVersionRequired': '请选择默认版本',
  'pages.versionManager.yes': '是',
  'pages.versionManager.no': '否',
  'pages.versionManager.cancel': '取消',
  'pages.versionManager.confirm': '确定',
  'pages.versionManager.getDetailFailed': '获取详情失败',
  'pages.versionManager.updateSuccess': '更新成功',
  'pages.versionManager.updateFailed': '更新失败，请重试',
  'pages.versionManager.missingModelId': '缺少模型ID，请重试',
  'pages.versionManager.missingVersionId': '缺少版本ID，请重试',
  'pages.versionManager.uploadSuccess': '上传成功！',
  'pages.versionManager.uploadFailed': '上传失败！',
  'pages.versionManager.fileIdMissing': '文件上传成功，但未返回文件ID！',
  'pages.versionManager.deploySuccess': '部署成功',
  'pages.versionManager.deployFailed': '部署失败，请重试',
  'pages.versionManager.addModel': '新增模型',
  'pages.versionManager.addSuccess': '新增成功',
  'pages.versionManager.addFailed': '新增失败，请重试',
  'pages.versionManager.modelName': '模型名称',
  'pages.versionManager.modelNamePlaceholder': '请输入模型名称',
  'pages.versionManager.modelNameRequired': '请输入模型名称',
  'pages.versionManager.modelNo': '模型编号',
  'pages.versionManager.modelNoPlaceholder': '请输入模型编号',
  'pages.versionManager.modelNoRequired': '请输入模型编号',
  'pages.versionManager.physicalType': '物性类型',
  'pages.versionManager.selectPhysicalType': '请选择物性类型',
  'pages.versionManager.physicalTypeRequired': '请选择物性类型',
  'pages.versionManager.versionDetail': '版本详情',

  'pages.versionManager.historyVersion': '历史版本',
  'pages.versionManager.basicData': '基础数据',
  'pages.versionManager.currentVersion': '当前版本',
  'pages.versionManager.versionNo': '版本编号',
  'pages.versionManager.status': '状态',
  'pages.versionManager.createTime': '创建时间',
  'pages.versionManager.operation': '操作',
  'pages.versionManager.performanceMetrics': '性能指标',
  'pages.versionManager.replaceSuccess': '替换成功',
  'pages.versionManager.replaceFailed': '替换失败，请重试',
  'pages.versionManager.confirmReplace': '确定要替换为该版本吗？',
  'pages.versionManager.replaceToThisVersion': '替换为该版本',
  'pages.versionManager.addVersion': '新增版本',
  // Dig Result Details
  'pages.digResult.details.comparisonAnalysis': '对比分析详情',
  'pages.digResult.details.physicalPropertyComparison': '物性参数对比分析',
  'pages.digResult.details.detailedDataTable': '详细数据表',
  'pages.digResult.details.dataAnalysisInsight': '数据分析与洞察',
  'pages.digResult.details.physicalTrendAnalysis': '物性趋势分析',
  'pages.digResult.details.applicationRecommendation': '应用建议',
  'pages.digResult.details.selectPhysicalParams': '选择物性参数',
  'pages.digResult.details.temperatureRange': '温度范围',
  'pages.digResult.details.dataSource': '数据来源',
  'pages.digResult.details.allDataSources': '所有数据来源',
  'pages.digResult.details.updateChart': '更新图表',
  'pages.digResult.details.temperature': '温度',
  'pages.digResult.details.physicalType': '物性类型',
  'pages.digResult.details.physicalValue': '物性值',
  'pages.digResult.details.dataSourceName': '数据来源',
  'pages.digResult.details.systemParamRequired': '体系参数不能为空',
  'pages.digResult.details.loadChartDataFailed': '加载图表数据失败，请稍后重试',
  'pages.digResult.details.noChartData': '暂无图表数据',
  'pages.digResult.details.dataVolume': '数据量',
  'pages.digResult.details.basedOnPhysicalData': '基于物性数据分析',
  'pages.digResult.details.physicalPropertyVsTemp': '物性参数随温度变化曲线',
  'pages.digResult.details.temperatureUnit': '温度(℃)',
  'pages.digResult.details.physicalValueLabel': '物性值',
  'pages.digResult.details.multiPhysicalVsTemp': '多物性参数随温度变化曲线',
  'pages.digResult.details.multiPhysicalComparison': '多物性参数对比分析',
  'pages.digResult.details.unknown': '未知',
  'pages.digResult.details.fittingCurve': '拟合曲线',
  'pages.digResult.details.physicalTrendAnalysisTitle': '物性趋势分析',
  // Physical Analysis
  'pages.physicalAnalysis.temperaturePropertyCurve': '温度-物性曲线',
  'pages.physicalAnalysis.temperatureAxis': '温度 (T/Tmin)',
  'pages.physicalAnalysis.propertyAxis': '物性',
  'pages.physicalAnalysis.noData': '暂无数据',
  'pages.physicalAnalysis.checkDataHint': '请检查物性数据是否包含有效的 factors 和温度信息',
  'pages.physicalAnalysis.property': '物性',
  'pages.physicalAnalysis.dataSource': '数据来源',
  'pages.physicalAnalysis.fittingFormula': '拟合公式',
  'pages.physicalAnalysis.fittingMethod': '拟合方式',
  // Property Temperature Correlation
  'pages.propertyTemperatureCorrelation.title': '物性-温度相关性分析',
  'pages.propertyTemperatureCorrelation.temperature': '温度',
  'pages.propertyTemperatureCorrelation.property': '物性',
  'pages.propertyTemperatureCorrelation.propertyValue': '物性值',
  'pages.propertyTemperatureCorrelation.unknownProperty': '未知物性',
  'pages.propertyTemperatureCorrelation.unknownSource': '未知来源',
  'pages.propertyTemperatureCorrelation.originalData': '原始数据',
  'pages.propertyTemperatureCorrelation.fittingCurve': '拟合曲线',
  'pages.propertyTemperatureCorrelation.noData': '暂无物性-温度相关性分析数据',
  'pages.propertyTemperatureCorrelation.noValidChartData': '暂无有效的图表数据',
  'pages.propertyTemperatureCorrelation.correlationInfo': '相关性分析信息',
  'pages.propertyTemperatureCorrelation.sampleSize': '样本数量',
  'pages.propertyTemperatureCorrelation.pearsonCoefficient': '皮尔逊相关系数 r',
  'pages.propertyTemperatureCorrelation.determinationCoefficient': '拟合优度 R²',
  'pages.propertyTemperatureCorrelation.slope': '斜率',
  'pages.propertyTemperatureCorrelation.intercept': '截距',
  'pages.propertyTemperatureCorrelation.fittingFormula': '拟合公式',
  // Property Coupling
  'pages.propertyCoupling.unknownSource': '未知来源',
  'pages.propertyCoupling.noData': '暂无多物性耦合关系数据',
  'pages.propertyCoupling.property': '物性',
  'pages.propertyCoupling.selectFirstProperty': '选择第一个物性',
  'pages.propertyCoupling.selectSecondProperty': '选择第二个物性',
  'pages.propertyCoupling.noMatchingData': '暂无符合条件的数据',
  'pages.propertyCoupling.selectTwoProperties': '请选择两个物性进行对比',
  // Version Manager Details
  'pages.versionManagerDetails.detail': '详情',
  'pages.versionManagerDetails.system': '体系',
  'pages.versionManagerDetails.physicalType': '物性类型',
  'pages.versionManagerDetails.physicalUnit': '物性单位',
  'pages.versionManagerDetails.component': '组分',
  'pages.versionManagerDetails.component1': '组分1',
  'pages.versionManagerDetails.component2': '组分2',
  'pages.versionManagerDetails.component3': '组分3',
  'pages.versionManagerDetails.component4': '组分4',
  'pages.versionManagerDetails.component5': '组分5',
  'pages.versionManagerDetails.dataSource': '数据来源',
  'pages.versionManagerDetails.tempUnit': '温度单位',
  'pages.versionManagerDetails.operation': '操作',
  'pages.versionManagerDetails.basicData': '基础数据',
  'pages.versionManagerDetails.meltingPoint': '熔点',
  'pages.versionManagerDetails.boilingPoint': '沸点',
  'pages.versionManagerDetails.meltingEnthalpy': '熔化焓',
  'pages.versionManagerDetails.surfaceTension': '表面张力',
  'pages.versionManagerDetails.contactAngle': '接触角',
  'pages.versionManagerDetails.thermalWeightLoss': '热失重',
  'pages.versionManagerDetails.chemicalData': '化学数据',
  'pages.versionManagerDetails.corrosiveness': '腐蚀性',
  'pages.versionManagerDetails.corrosionPotential': '腐蚀电位',
  'pages.versionManagerDetails.thermalStabilityWindow': '热稳定性窗口',
  'pages.versionManagerDetails.thermalStabilityWidth': '热稳定性宽度',
  'pages.versionManagerDetails.electrochemicalWindow': '电化学窗口',
  'pages.versionManagerDetails.experimentalData': '试验数据',
  'pages.versionManagerDetails.sampleAmount': '样品量',
  'pages.versionManagerDetails.testDate': '测试日期',
  'pages.versionManagerDetails.tester': '测试人',
  'pages.versionManagerDetails.testInstitution': '测试机构',
  'pages.versionManagerDetails.atmosphere': '气氛',
  'pages.versionManagerDetails.impurityConcentration': '杂质浓度',
  // Physical Data Table
  'pages.physicalDataTable.noData': '暂无物性数据',
  'pages.physicalDataTable.dataSource': '数据来源',
  'pages.physicalDataTable.system': '体系',
  'pages.physicalDataTable.physicalType': '物性类型',
  'pages.physicalDataTable.physicalUnit': '物性单位',
  'pages.physicalDataTable.tempUnit': '温度单位',
  // Basic Statistics Analysis
  'pages.basicStatisticsAnalysis.title': '基础统计分析',
  'pages.basicStatisticsAnalysis.tooltip': '对熔盐物性数据进行基本统计计算和多条件对比分析',
  'pages.basicStatisticsAnalysis.selectSystem': '选择熔盐',
  'pages.basicStatisticsAnalysis.selectSystemPlaceholder': '选择熔盐',
  'pages.basicStatisticsAnalysis.system': '体系',
  'pages.basicStatisticsAnalysis.temperatureInterval': '温度区间',
  'pages.basicStatisticsAnalysis.mean': '均值',
  'pages.basicStatisticsAnalysis.standardDeviation': '标准差',
  'pages.basicStatisticsAnalysis.multiConditionCompare': '多组条件对比',
  'pages.basicStatisticsAnalysis.differentTemperatureIntervals': '在不同温度区间',
  'pages.basicStatisticsAnalysis.meanDifference': '均值差异',
  // Distribution Analysis
  'pages.distributionAnalysis.title': '分布分析',
  'pages.distributionAnalysis.property': '物性',
  'pages.distributionAnalysis.unknownSource': '未知来源',
  'pages.distributionAnalysis.densityEstimate': '密度估计',
  'pages.distributionAnalysis.normalityTestInfo': '正态性检验信息',
  'pages.distributionAnalysis.normalDistribution': '符合正态分布',
  'pages.distributionAnalysis.nonNormalDistribution': '不符合正态分布',
  'pages.distributionAnalysis.sampleSize': '样本数量',
  'pages.distributionAnalysis.mean': '均值',
  'pages.distributionAnalysis.standardDeviation': '标准差',
  'pages.distributionAnalysis.variance': '方差',
  'pages.distributionAnalysis.rightSkewed': '右偏态',
  'pages.distributionAnalysis.leftSkewed': '左偏态',
  'pages.distributionAnalysis.symmetricDistribution': '对称分布',
  'pages.distributionAnalysis.kurtosis': '峰度',
  'pages.distributionAnalysis.jarqueBera': 'Jarque-Bera统计量',
  'pages.distributionAnalysis.comment': '备注',
  'pages.distributionAnalysis.noData': '暂无分布数据',
  // Principal Component Analysis
  'pages.principalComponentAnalysis.noData': '暂无PCA分析数据',
  'pages.principalComponentAnalysis.unknownSource': '未知来源',
  'pages.principalComponentAnalysis.unknownSystem': '未知体系',
  'pages.principalComponentAnalysis.pc1': '第一主成分 (PC1)',
  'pages.principalComponentAnalysis.pc2': '第二主成分 (PC2)',
  'pages.principalComponentAnalysis.pcaInfo': 'PCA分析信息',
  'pages.principalComponentAnalysis.system': '体系',
  'pages.principalComponentAnalysis.sampleSize': '样本数量',
  'pages.principalComponentAnalysis.explainedVariancePc1': '第一主成分解释方差比',
  'pages.principalComponentAnalysis.explainedVariancePc2': '第二主成分解释方差比',
  'pages.principalComponentAnalysis.comment': '备注',
  'pages.principalComponentAnalysis.noScatterData': '暂无PCA散点图数据',
  // Correlation Heatmap
  'pages.correlationHeatmap.noData': '暂无相关性矩阵热图数据',
  'pages.correlationHeatmap.unknownSource': '未知来源',
  'pages.correlationHeatmap.property': '物性',
  'pages.correlationHeatmap.correlationCoefficient': '相关系数',
  // Physical Statistics Card
  'pages.physicalStatisticsCard.mean': '均值',
  'pages.physicalStatisticsCard.variance': '方差',
  'pages.physicalStatisticsCard.unknownSource': '未知来源',
  'pages.physicalStatisticsCard.noStatistics': '暂无统计数据',
  'pages.physicalStatisticsCard.property': '物性',
  // Correlation Analysis
  'pages.correlationAnalysis.title': '相关性分析',
  'pages.correlationAnalysis.propertyTemperatureCorrelation': '物性-温度相关性分析',
  'pages.correlationAnalysis.propertyCoupling': '多物性之间的耦合关系',
  'pages.correlationAnalysis.correlationHeatmap': '相关性矩阵热图',
  'pages.correlationAnalysis.principalComponentAnalysis': '主要成分分析（PCA）',
  // Create Task Modal
  'pages.createTaskModal.title': '创建ETL任务',
  'pages.createTaskModal.taskName': '任务名称',
  'pages.createTaskModal.taskNamePlaceholder': '请输入任务名称',
  'pages.createTaskModal.taskNameRequired': '请输入任务名称',
  'pages.createTaskModal.dataSourceType': '数据来源类型',
  'pages.createTaskModal.selectDataSourceType': '请选择数据来源类型',
  'pages.createTaskModal.dataSourceTypeRequired': '请选择数据来源类型',
  'pages.createTaskModal.dataSourceDetail': '具体来源',
  'pages.createTaskModal.selectDataSourceDetail': '请选择具体来源',
  'pages.createTaskModal.dataSourceDetailRequired': '请选择具体来源',
  'pages.createTaskModal.fileFormat': '文件格式',
  'pages.createTaskModal.selectFileFormat': '请选择文件格式',
  'pages.createTaskModal.fileFormatRequired': '请选择文件格式',
  'pages.createTaskModal.uploadFile': '上传文件',
  'pages.createTaskModal.uploadFileRequired': '请上传文件',
  'pages.createTaskModal.uploadHint': '点击或拖拽文件到此处上传',
  'pages.createTaskModal.uploadFormatHint': '支持 {formats} 格式，文件大小不超过 100MB',
  'pages.createTaskModal.unsupportedFormat': '只支持 {formats} 格式的文件！',
  'pages.createTaskModal.fileSizeExceeded': '文件大小不能超过 100MB！',
  'pages.createTaskModal.uploadSuccess': '{fileName} 上传成功！',
  'pages.createTaskModal.uploadFailed': '{fileName} 上传失败！',
  'pages.createTaskModal.pleaseUploadFile': '请先上传文件！',
  'pages.createTaskModal.createSuccess': '任务创建成功！',
  'pages.createTaskModal.createFailed': '任务创建失败',
  'pages.createTaskModal.createFailedRetry': '创建任务失败，请稍后重试',
  // Task Detail Modal
  'pages.taskDetailModal.title': '任务详情',
  'pages.taskDetailModal.basicInfo': '任务基本信息',
  'pages.taskDetailModal.taskNo': '任务编号',
  'pages.taskDetailModal.taskName': '任务名称',
  'pages.taskDetailModal.dataSourceType': '数据来源类型',
  'pages.taskDetailModal.dataSourceDetail': '具体来源',
  'pages.taskDetailModal.fileFormat': '文件格式',
  'pages.taskDetailModal.fileName': '文件名',
  'pages.taskDetailModal.taskStatus': '任务状态',
  'pages.taskDetailModal.createTime': '创建时间',
  'pages.taskDetailModal.startTime': '开始时间',
  'pages.taskDetailModal.endTime': '结束时间',
  'pages.taskDetailModal.errorMessage': '错误信息',
  'pages.taskDetailModal.processingProgress': '处理进度',
  'pages.taskDetailModal.totalProgress': '总进度',
  'pages.taskDetailModal.extractProgress': '抽取进度',
  'pages.taskDetailModal.transformProgress': '转换进度',
  'pages.taskDetailModal.loadProgress': '加载进度',
  'pages.taskDetailModal.recordStatistics': '记录统计',
  'pages.taskDetailModal.totalRecords': '总记录数',
  'pages.taskDetailModal.extractedRecords': '已抽取记录数',
  'pages.taskDetailModal.transformedRecords': '已转换记录数',
  'pages.taskDetailModal.loadedRecords': '已加载记录数',
  'pages.taskDetailModal.pending': '待处理',
  'pages.taskDetailModal.extracting': '抽取中',
  'pages.taskDetailModal.transforming': '转换中',
  'pages.taskDetailModal.loading': '加载中',
  'pages.taskDetailModal.completed': '已完成',
  'pages.taskDetailModal.failed': '失败',
  'pages.taskDetailModal.inProgress': '进行中',
  // Task Submit
  'pages.taskSubmit.submitSuccess': '任务提交成功',
  'pages.taskSubmit.submitFailed': '任务提交失败，请重试',
  'pages.taskSubmit.taskName': '任务名称',
  'pages.taskSubmit.taskNamePlaceholder': '请输入任务名称',
  'pages.taskSubmit.taskNameRequired': '请输入任务名称',
  'pages.taskSubmit.taskDescription': '任务描述',
  'pages.taskSubmit.taskDescriptionPlaceholder': '请输入任务描述',
  'pages.taskSubmit.inputSystem': '输入体系',
  'pages.taskSubmit.inputSystemPlaceholder': '请输入输入体系',
  'pages.taskSubmit.selectDataSource': '请选择数据库',
  'pages.taskSubmit.selectPhysicalType': '请选择物性类型',
  'pages.taskSubmit.taskType': '任务类型',
  'pages.taskSubmit.selectTaskType': '请选择任务类型',
  'pages.taskSubmit.taskTypeRequired': '请选择任务类型',
  'pages.taskSubmit.modelType': '模型选择',
  'pages.taskSubmit.selectModel': '请选择模型',
  'pages.taskSubmit.modelTypeRequired': '请选择模型',
  'pages.taskSubmit.compositionRatio': '组分比',
  'pages.taskSubmit.compositionRatioTooltip': '例如：20-40mol%',
  'pages.taskSubmit.compositionRatioPlaceholder': '例如：20-40mol%',
  'pages.taskSubmit.temperatureRange': '温度区间',
  'pages.taskSubmit.temperatureRangeTooltip': '例如：500-600°C',
  'pages.taskSubmit.temperatureRangePlaceholder': '例如：500-600°C',
  'pages.taskSubmit.submitTask': '提交分析任务',
  // More Details Modal
  'pages.moreDetails.title': '分析结果可视化',
  'pages.moreDetails.getResultFailed': '获取任务结果失败',
  'pages.moreDetails.getResultFailedRetry': '获取任务结果失败，请重试',
  'pages.moreDetails.taskIdNotExists': '任务ID不存在',
  'pages.moreDetails.downloadPngStarted': '开始下载PNG图表',
  'pages.moreDetails.downloadCsvStarted': '开始下载CSV数据',
  'pages.moreDetails.chartDataParseFailed': '图表数据解析失败或格式不正确',
  'pages.moreDetails.noChartData': '暂无图表数据',
  'pages.moreDetails.fittingResult': '拟合结果',
  'pages.moreDetails.fittingModel': '拟合模型',
  'pages.moreDetails.goodnessOfFit': '拟合优度',
  'pages.moreDetails.activationEnergy': '活化能',
  'pages.moreDetails.preExponentialFactor': '指前因子',
  'pages.moreDetails.arrheniusEquation': 'Arrhenius方程',
  'pages.moreDetails.relationChart': '关系曲线图',
  'pages.moreDetails.statisticalInfo': '统计信息',
  'pages.moreDetails.dataPoints': '数据点数',
  'pages.moreDetails.temperatureRange': '温度范围',
  'pages.moreDetails.propertyRange': '物性范围',
  'pages.moreDetails.standardError': '标准误差',
  'pages.moreDetails.resultData': '结果数据',
  'pages.moreDetails.totalRecords': '共 {total} 条数据',
  'pages.moreDetails.downloadChart': '下载图表(PNG)',
  'pages.moreDetails.downloadData': '下载数据(CSV)',
  'pages.moreDetails.noVisualizationData': '暂无可视化数据',
  // Workflow Target Details
  'pages.experimentCalculate.workflowTargetDetails': '工作流目标详情',
  'pages.experimentCalculate.coreObjectives': '实验-计算联合工作流的核心目标',
  'pages.experimentCalculate.coreObjectivesDesc': '建立实验测量与计算模拟之间的无缝连接，形成数据驱动的材料研发闭环，实现从实验验证到性能预测再到优化设计的完整工作流程。',
  'pages.experimentCalculate.dataInteroperability': '数据互通',
  'pages.experimentCalculate.dataInteroperabilityDesc': '实现实验数据与仿真数据的双向流动与相互验证',
  'pages.experimentCalculate.experimentalDataStandardization': '实验数据标准化',
  'pages.experimentCalculate.unifiedFormatUnits': '统一格式与单位',
  'pages.experimentCalculate.simulationParameterOptimization': '仿真参数优化',
  'pages.experimentCalculate.basedOnExperimentalData': '基于实验数据校正',
  'pages.experimentCalculate.modelCorrection': '模型校正',
  'pages.experimentCalculate.modelCorrectionDesc': '利用实验数据优化计算模型的参数，提高预测精度',
  'pages.experimentCalculate.parameterSensitivityAnalysis': '参数敏感性分析',
  'pages.experimentCalculate.identifyKeyParameters': '识别关键参数',
  'pages.experimentCalculate.modelValidation': '模型验证',
  'pages.experimentCalculate.compareResults': '对比实验与仿真结果',
  'pages.experimentCalculate.blankFilling': '空白填补',
  'pages.experimentCalculate.blankFillingDesc': '通过计算模拟补全实验难以测量的极端条件',
  'pages.experimentCalculate.extremeConditionsPrediction': '极端条件预测',
  'pages.experimentCalculate.highTempHighPressure': '高温、高压等',
  'pages.experimentCalculate.multiscaleSimulation': '多尺度模拟',
  'pages.experimentCalculate.fromAtomToMacro': '从原子到宏观',
  'pages.experimentCalculate.accelerateDevelopment': '加速研发',
  'pages.experimentCalculate.accelerateDevelopmentDesc': '缩短新材料从设计到验证的周期，降低研发成本',
  'pages.experimentCalculate.highThroughputComputing': '高通量计算',
  'pages.experimentCalculate.quickScreenCandidateMaterials': '快速筛选候选材料',
  'pages.experimentCalculate.intelligentRecommendation': '智能推荐',
  'pages.experimentCalculate.optimizeBasedOnHistoricalData': '基于历史数据优化',
  // Result Download

  'pages.resultDownload.startWorkflowFailed': '工作流启动失败，请重试',

  'pages.resultDownload.workflowNamePlaceholder': '请输入工作流名称',
  'pages.resultDownload.workflowNameRequired': '请输入工作流名称',

  'pages.resultDownload.selectWorkflowType': '请选择工作流类型',
  'pages.resultDownload.workflowTypeRequired': '请选择工作流类型',

  'pages.resultDownload.selectPriority': '请选择优先级',
  'pages.resultDownload.executionProgress': '执行进度',

  'pages.resultDownload.operation': '操作',
  'pages.resultDownload.startNewWorkflow': '启动新工作流',
  'pages.resultDownload.immediateStart': '是否立即启动',
  'pages.resultDownload.startImmediately': '立即启动',
  'pages.resultDownload.createOnly': '仅创建',
  'pages.resultDownload.workflowDescription': '工作流描述',
  'pages.resultDownload.workflowDescriptionPlaceholder': '请输入工作流描述',
  'pages.resultDownload.fileUpload': '文件上传',
  'pages.resultDownload.selectFileUpload': '选择文件上传',
  'pages.resultDownload.fileUploaded': '文件已上传，ID: {fileId}',
  'pages.resultDownload.inputParameters': '输入参数(JSON)',
  'pages.resultDownload.inputParametersPlaceholder': '请输入JSON格式的输入参数，例如：{"key":"value"}。上传文件后，文件ID会自动添加到输入参数中。',
  'pages.resultDownload.configData': '配置数据(JSON)',
  'pages.resultDownload.configDataPlaceholder': '请输入JSON格式的配置数据，例如：{"key":"value"}',
  'pages.resultDownload.templateId': '模板ID',
  'pages.resultDownload.templateIdPlaceholder': '请输入模板ID（可选）',
  'pages.resultDownload.submitWorkflow': '提交工作流',
  'pages.resultDownload.queuedWorkflows': '正在排队的工作流',
  'pages.resultDownload.historyWorkflows': '历史工作流',
  'pages.resultDownload.searchWorkflowName': '搜索工作流名称',
  'pages.resultDownload.selectStatus': '选择状态',
  'pages.resultDownload.viewDetails': '查看详情',
  'pages.resultDownload.downloadReport': '下载报告',
  // TaskSubmit Additional Translations
  'pages.experimentCalculate.densityDataDriven': '密度数据驱动',
  'pages.experimentCalculate.densityDataDrivenDesc': '实验密度结果用于校正DFT计算体积，提高计算精度',
  'pages.experimentCalculate.uploadDensityData': '上传实验密度数据',
  'pages.experimentCalculate.correctDftVolume': '校正DFT计算体积',
  'pages.experimentCalculate.improveAccuracy': '提高计算精度',
  'pages.experimentCalculate.simulationDataFillGaps': '仿真数据补全实验空白',
  'pages.experimentCalculate.extremeConditionPrediction': '极端条件预测',
  'pages.experimentCalculate.extremeConditionPredictionDesc': '极端条件(>1000°C)实验难以测量，自动触发MD/DFT预测物性',
  'pages.experimentCalculate.identifyGaps': '识别实验空白区域',
  'pages.experimentCalculate.triggerMdDft': '自动触发MD/DFT计算',
  'pages.experimentCalculate.predictExtremeProperties': '预测极端条件物性',
  'pages.experimentCalculate.phaseDiagramCompletion': '相图计算补全',
  'pages.experimentCalculate.phaseDiagramCompletionDesc': 'CALPHAD相图计算补充多组分相稳定性信息',
  'pages.experimentCalculate.inputMultiComponent': '输入多组分体系',
  'pages.experimentCalculate.calphadCalculation': 'CALPHAD相图计算',
  'pages.experimentCalculate.supplementPhaseStability': '补充相稳定性信息',
  // TaskSubmit Components Additional Translations

  // Details3.tsx - Step 2 Simulation Tools

  'pages.experimentCalculate.step3.mdTitle': '分子动力学(MD)',
  'pages.experimentCalculate.step3.mdDesc': '模拟熔盐微观结构与输运性质',
  'pages.experimentCalculate.step3.toolLammps': 'LAMMPS',
  'pages.experimentCalculate.step3.toolGromacs': 'GROMACS',
  'pages.experimentCalculate.step3.toolCustom': '自定义力场',
  'pages.experimentCalculate.step3.dftTitle': '密度泛函理论(DFT)',
  'pages.experimentCalculate.step3.dftDesc': '计算电子结构与热力学性质',
  'pages.experimentCalculate.step3.toolVasp': 'VASP',
  'pages.experimentCalculate.step3.toolQe': 'Quantum ESPRESSO',
  'pages.experimentCalculate.step3.toolCastep': 'CASTEP',
  'pages.experimentCalculate.step3.calphadTitle': 'CALPHAD方法',
  'pages.experimentCalculate.step3.calphadDesc': '计算相图与热力学性质',
  'pages.experimentCalculate.step3.toolThermoCalc': 'Thermo-Calc',
  'pages.experimentCalculate.step3.toolFactSage': 'FactSage',
  'pages.experimentCalculate.step3.toolPandat': 'Pandat',
  // Details4.tsx - Step 4 Verification & Optimization

  // Details5.tsx - Step 5 Performance Prediction

  // MoreDetails.tsx - Analysis Result Visualization

  // Details2.tsx - Step 1 Experimental Data
  'pages.experimentCalculate.step2.viscosityData': '粘度数据',
  'pages.experimentCalculate.step2.viscosityRelation': 'η-T关系',
  'pages.experimentCalculate.step2.densityData': '密度数据',
  'pages.experimentCalculate.step2.densityRelation': 'ρ-T关系',
  'pages.experimentCalculate.step2.specificHeatData': '比热数据',
  'pages.experimentCalculate.step2.specificHeatRelation': 'Cp-T关系',
  'pages.experimentCalculate.step2.thermalConductivityData': '热导率数据',
  'pages.experimentCalculate.step2.thermalConductivityRelation': 'λ-T关系',
  'pages.experimentCalculate.step2.electricalConductivityData': '电导率数据',
  'pages.experimentCalculate.step2.electricalConductivityRelation': 'σ-T关系',

  // Additional ResultDownload Keys
  'pages.resultDownload.parameter': '参数',
  'pages.resultDownload.experimentalValue': '实验值',
  'pages.resultDownload.simulationValue': '仿真值',
  'pages.resultDownload.error': '误差',
  'pages.resultDownload.status': '状态',
  'pages.resultDownload.workflowHistoryDetail': '工作流历史详情',

  'pages.resultDownload.estimated': '预计',
  'pages.resultDownload.minutes': '分钟',
  'pages.resultDownload.processingLog': '处理日志',
  'pages.resultDownload.workflowCompleted': '工作流执行完成',
  'pages.resultDownload.downloadFullReport': '下载完整报告',


  // DataFlow Additional Translations
  'pages.dataFlow.taskList': '任务列表',
  'pages.dataFlow.createEtlTask': '创建ETL任务',
  'pages.dataFlow.refresh': '刷新',
  'pages.dataFlow.dataExtract': '数据抽取',
  'pages.dataFlow.dataTransform': '数据转换',
  'pages.dataFlow.dataLoad': '数据加载',
  'pages.dataFlow.supportedFormats': '支持格式',
  'pages.dataFlow.unitStandardization': '单位统一',
  'pages.dataFlow.dataCleaning': '数据清洗',
  'pages.dataFlow.dataCleaningDesc': '异常点剔除、曲线平滑',
  'pages.dataFlow.missingDataCompletion': '缺失补全',
  'pages.dataFlow.missingDataCompletionDesc': '插值/基于ML预测',
  'pages.dataFlow.metadataStandardization': '元数据标准化',
  'pages.dataFlow.metadataStandardizationDesc': '实验条件、仿真参数标准化',
  'pages.dataFlow.dataWarehouse': '数据仓库',
  'pages.dataFlow.writeToDataWarehouse': '写入熔盐物性数据仓库',
  'pages.dataFlow.versionManagement': '版本管理',
  'pages.dataFlow.versionManagementDesc': '保留原始数据 + 转换后数据',
  'pages.dataFlow.dataLabeling': '数据标签化',
  'pages.dataFlow.dataLabelingExample': '如：LiF–BeF₂ (66–34 mol%) | 850 ℃ | η = 2.5 mPa·s',
  'pages.dataFlow.etlPipelineTitle': 'ETL数据处理流水线',
  'pages.dataFlow.getTaskDetailFailed': '获取任务详情失败',
  'pages.dataFlow.getTaskDetailFailedRetry': '获取任务详情失败，请稍后重试',
  'pages.dataFlow.deleteSuccess': '删除成功',
  'pages.dataFlow.deleteFailed': '删除失败',
  'pages.dataFlow.deleteFailedRetry': '删除任务失败，请稍后重试',
  // ProjectExperience Additional Translations
  'pages.projectExperience.queryFailed': '查询失败',
  'pages.projectExperience.keyword': '关键字',
  'pages.projectExperience.projectType': '项目类型',
  'pages.projectExperience.other': '其他',
  'pages.projectExperience.runningData': '运行数据',
  'pages.projectExperience.projectName': '项目名称',
  'pages.projectExperience.saltSystem': '熔盐体系',
  'pages.projectExperience.viewSolution': '查看解决方案',
  'pages.projectExperience.viewReport': '查看详细报告',
  'pages.projectExperience.inputQuery': '请输入查询条件进行搜索',
  'pages.projectExperience.noData': '暂无数据',
  // PerformancePrediction
  'pages.performancePrediction.title': '性能预测',
  'pages.performancePrediction.params': '预测参数',

  'pages.performancePrediction.saltSystem.required': '请输入盐体系成分',
  'pages.performancePrediction.saltSystem.extra': '例如:LiF-BeF2 45-55 mol% 或 LiF-BeF2',
  'pages.performancePrediction.saltSystem.placeholder': '例如:LiF-BeF2 45-55 mol% 或 LiF-BeF2',

  'pages.performancePrediction.temperatureMin.required': '请输入最小温度',
  'pages.performancePrediction.temperatureMin.placeholder': '例如: 500',
  'pages.performancePrediction.temperatureMax.required': '请输入最大温度',
  'pages.performancePrediction.temperatureMax.placeholder': '例如: 800',
  'pages.performancePrediction.impurityConcentration': '杂质浓度(JSON格式)',
  'pages.performancePrediction.impurityConcentration.extra': '可选,JSON格式,如:{"元素名":浓度值} 例如:{"Fe": 0.01, "Ni": 0.005}',
  'pages.performancePrediction.impurityConcentration.placeholder': '例如:{"Fe": 0.01, "Ni": 0.005}',
  'pages.performancePrediction.impurityFormatError': '杂质浓度格式错误，请检查JSON格式',
  'pages.performancePrediction.processParameters': '工艺参数(JSON格式)',
  'pages.performancePrediction.processParameters.extra': '可选,JSON格式,如:{"参数名":参数值} 例如:{"pressure": 1.0, "atmosphere": "argon"}',
  'pages.performancePrediction.processParameters.placeholder': '例如:{"pressure": 1.0, "atmosphere": "argon"}',
  'pages.performancePrediction.processFormatError': '工艺参数格式错误，请检查JSON格式',

  'pages.performancePrediction.algorithmType.required': '请选择算法类型',
  'pages.performancePrediction.algorithmType.extra': '回归模型:随机森林、XGBoost、神经网络;深度学习模型:图神经网络(GNN)',
  'pages.performancePrediction.algorithmType.placeholder': '请选择算法',
  'pages.performancePrediction.start': '开始预测',
  'pages.performancePrediction.reset': '重置',
  'pages.performancePrediction.success': '预测成功',
  'pages.performancePrediction.failure': '预测失败，请重试',
  'pages.performancePrediction.copySuccess': 'JSON数据已复制到剪贴板',
  'pages.performancePrediction.tip': '操作提示',
  'pages.performancePrediction.tip.description': '请在左侧填写预测参数,然后点击"开始预测"按钮',
  // MeterialGraph
  'pages.meterialGraph.querySuccess': '查询成功',
  'pages.meterialGraph.queryFailed': '查询失败',
  'pages.meterialGraph.queryFailedRetry': '查询失败，请稍后重试',
  'pages.meterialGraph.inputQuery': '请输入查询内容',
  'pages.meterialGraph.system': '体系',
  'pages.meterialGraph.nodeType': '节点类型',
  'pages.meterialGraph.all': '全部',
  'pages.meterialGraph.temperatureRange': '温度范围',
  'pages.meterialGraph.physicalType': '物性类型',
  'pages.meterialGraph.emptyDescription': '请在上方输入查询条件，点击查询按钮生成知识图谱和体系信息',
  'pages.meterialGraph.knowledgeGraph': '知识图谱',
  'pages.meterialGraph.generating': '知识图谱生成中...',
  'pages.meterialGraph.currentSystemInfo': '当前体系信息',
  'pages.meterialGraph.unknownSystem': '未知体系',
  'pages.meterialGraph.noDescription': '暂无描述',
  'pages.meterialGraph.compositionNodes': '成分节点',
  'pages.meterialGraph.unknownNode': '未知节点',
  'pages.meterialGraph.processNodes': '工艺节点',
  'pages.meterialGraph.performanceNodes': '性能节点',
  'pages.meterialGraph.environmentNodes': '环境节点',
  'pages.meterialGraph.loadingSystemInfo': '体系信息加载中...',
  'pages.meterialGraph.systemQueryAnalysis': '体系查询与分析',
  'pages.meterialGraph.systemCompare': '体系对比',
  'pages.meterialGraph.systemCompareDesc': '选择不同体系查看其成分-工艺-性能关系差异',
  'pages.meterialGraph.multiQuery': '多维查询',
  'pages.meterialGraph.multiQueryDesc': '支持跨体系查询，如："哪种氯盐体系在850℃下导热率数值？"',
  'pages.meterialGraph.knowledgeGraphQuery': '知识图谱查询',
  'pages.meterialGraph.queryPlaceholder': '查询，如："哪种氯盐体系在850℃下导热率数值？"',
  'pages.meterialGraph.query': '查询',
  'pages.meterialGraph.queryResult': '查询结果：',
  'pages.meterialGraph.relatedSystems': '相关体系',
  'pages.meterialGraph.emptyQueryDesc': '请输入查询内容，点击查询按钮获取结果',
  // PropertiesGrouper
  'pages.propertiesGrouper.title': '共晶盐筛选',
  'pages.propertiesGrouper.saltSystem': '盐体系成分',
  'pages.propertiesGrouper.saltSystem.label': '盐体系成分 *',
  'pages.propertiesGrouper.saltSystem.required': '请输入盐体系成分',
  'pages.propertiesGrouper.saltSystem.extra': '支持格式: LiF-BeF2 45-55 mol% 或直接输入 LiF-BeF2',
  'pages.propertiesGrouper.saltSystem.placeholder': '例如: LiF-BeF2 45-55 mol%',
  'pages.propertiesGrouper.analysisType.label': '分析类型 *',
  'pages.propertiesGrouper.analysisType.required': '请选择分析类型',
  'pages.propertiesGrouper.analysisType.placeholder': '请选择分析类型',
  'pages.propertiesGrouper.classification': '分类: 预测盐体系类别(稳定/不稳定、腐蚀性等级)',
  'pages.propertiesGrouper.clustering': '聚类: 根据物性相似度对多元盐进行聚类',
  'pages.propertiesGrouper.analysisMethod.label': '分析方法 (可选)',
  'pages.propertiesGrouper.analysisMethod.extra': '可选, 如果不选择将使用默认方法',
  'pages.propertiesGrouper.analysisMethod.placeholder': '请选择分析方法 (可选)',
  'pages.propertiesGrouper.start': '开始筛选',
  'pages.propertiesGrouper.reset': '重置',
  'pages.propertiesGrouper.success': '筛选成功',
  'pages.propertiesGrouper.failure': '筛选失败，请重试',
  'pages.propertiesGrouper.tip': '操作提示',
  'pages.propertiesGrouper.tip.description': '请在左侧填写筛选参数, 然后点击"开始筛选"按钮',
  // Dynamic Periodic Table
  'pages.dynamicPeriodic.atomicNumber': '原子序数',
  'pages.dynamicPeriodic.atomicMass': '原子量',
  'pages.dynamicPeriodic.electronConfig': '电子排布',
  'pages.dynamicPeriodic.discoveredBy': '发现人',
  'pages.dynamicPeriodic.unknown': '未知',
  'pages.dynamicPeriodic.category': '分类',
  'pages.dynamicPeriodic.preview': '预览',
  'pages.dynamicPeriodic.wikipediaLink': 'Wikipedia 链接',
  'pages.dynamicPeriodic.bohrModel': '玻尔模型',
  'pages.dynamicPeriodic.bohrModelAlt': '{name} 玻尔模型',
  'pages.dynamicPeriodic.electronTable': '标准原子带电子量',
  'pages.dynamicPeriodic.electronShell': '电子层',
  'pages.dynamicPeriodic.orbitalElectrons': '{orbital}轨道电子数',
  'pages.dynamicPeriodic.clickToView': '点击元素查看详情',
  // Data Import Record
  'pages.dataImport.all': '全部',
  'pages.dataImport.record.createTime': '创建时间',
  'pages.dataImport.record.createUser': '创建人',
  'pages.dataImport.record.createType': '创建方式',
  'pages.dataImport.record.dataCount': '数据量（条）',
  'pages.dataImport.record.status': '状态',
  'pages.dataImport.record.sourceFile': '源文件',
  'pages.dataImport.record.approvalOpinion': '审批意见',
  'pages.dataImport.record.operation': '操作',
  'pages.dataImport.record.approve': '审批',
  'pages.dataImport.record.approvalResult': '审批结果',
  'pages.dataImport.record.edit': '修改',
  'pages.dataImport.record.cannotGetBatchId': '无法获取批次ID',
  'pages.dataImport.record.detail': '详情',
  'pages.dataImport.record.tTmin': 'T/Tmin',
  'pages.dataImport.record.tmax': 'Tmax',
  'pages.dataImport.record.importRecordList': '导入记录列表',
  // Details Modal
  'pages.dataImport.record.simulationDataInfo': '仿真计算结果数据信息',
  'pages.dataImport.record.system': '体系',
  'pages.dataImport.record.physicalType': '物性类型',
  'pages.dataImport.record.physicalUnit': '物性单位',
  'pages.dataImport.record.dataSource': '数据来源',
  'pages.dataImport.record.tempUnit': '温度单位',
  'pages.dataImport.record.algorithm': '仿真算法',
  'pages.dataImport.record.index': '序号',
  'pages.dataImport.record.component': '组分',
  'pages.dataImport.record.coefficient': '系数',
  'pages.dataImport.record.getDetailFailed': '获取详情失败',
  'pages.dataImport.record.missingParams': '缺少必要参数',
  'pages.dataImport.record.batchInfo': '批次信息',
  'pages.dataImport.record.batchNo': '批次号',
  'pages.dataImport.record.reportFile': '报表文件',
  'pages.dataImport.record.approvalName': '审批人',
  'pages.dataImport.record.baseData': '基础数据',
  'pages.dataImport.record.meltingPoint': '熔点',
  'pages.dataImport.record.boilingPoint': '沸点',
  'pages.dataImport.record.meltingEnthalpy': '熔化焓',
  'pages.dataImport.record.surfaceTension': '表面张力',
  'pages.dataImport.record.contactAngle': '接触角',
  'pages.dataImport.record.thermalWeightLoss': '热失重',
  'pages.dataImport.record.vaporPressure': '蒸汽压',
  'pages.dataImport.record.chemicalData': '化学数据',
  'pages.dataImport.record.corrosive': '腐蚀性',
  'pages.dataImport.record.corrosionPotential': '腐蚀电位',
  'pages.dataImport.record.thermalStabilityWindow': '热稳定性窗口',
  'pages.dataImport.record.thermalStabilityWidth': '热稳定性宽度',
  'pages.dataImport.record.electrochemistryWindow': '电化学窗口',
  'pages.dataImport.record.testData': '试验数据',
  'pages.dataImport.record.sampleSize': '样品量',
  'pages.dataImport.record.testTime': '测试时间',
  'pages.dataImport.record.testPerson': '测试人',
  'pages.dataImport.record.testingAgency': '测试机构',
  'pages.dataImport.record.atmosphere': '气氛',
  'pages.dataImport.record.impurityConcentration': '杂质浓度',
  'pages.dataImport.record.boxSize': '模拟盒尺寸',
  'pages.dataImport.record.boxStepLength': '模拟盒步长',
  'pages.dataImport.record.potentialFunc': '势函数类型',
  'pages.dataImport.record.simulationAlgorithm': '仿真算法',
  'pages.dataImport.record.simulationData': '仿真数据',
  // Data Upload Record
  'pages.dataUpload.all': '全部',
  'pages.dataUpload.record.createTime': '创建时间',
  'pages.dataUpload.record.createUser': '创建人',
  'pages.dataUpload.record.createType': '创建方式',
  'pages.dataUpload.record.dataSource': '数据来源',
  'pages.dataUpload.record.dataCount': '数据量（条）',
  'pages.dataUpload.record.approvalName': '审批人',
  'pages.dataUpload.record.status': '状态',
  'pages.dataUpload.record.sourceFile': '源文件',
  'pages.dataUpload.record.approvalOpinion': '审批意见',
  'pages.dataUpload.record.operation': '操作',
  'pages.dataUpload.record.approve': '审批',
  'pages.dataUpload.record.approvalResult': '审批结果',
  'pages.dataUpload.record.edit': '修改',
  'pages.dataUpload.record.importRecordList': '导入记录列表',
  // Third Import Nist
  'pages.nist.system': '体系',
  'pages.nist.physicalPropType': '物性类型',
  'pages.nist.all': '全部',
  'pages.nist.externalDataInfo': '外部数据信息',
  'pages.nist.dataSource': '数据来源',
  'pages.nist.database': 'NIST数据库',
  'pages.nist.physicalUnit': '物性单位',
  'pages.nist.index': '序号',
  'pages.nist.component': '组分',
  'pages.nist.coefficient': '系数',
  'pages.nist.tempUnit': '温度单位',
  'pages.nist.dataType': '数据类型',
  'pages.nist.moreActions': '更多操作',
  'pages.nist.detail': '详情',
  'pages.nist.externalDataDetail': '外部数据详情',
  'pages.nist.confirm': '确定',
  'pages.nist.comment': '注释',
  'pages.nist.formatComment': '格式化注释',
  'pages.nist.syncTime': '同步时间',
  // Third Import MatWeb
  'pages.matweb.keyword': '通配关键字',
  'pages.matweb.index': '序号',
  'pages.matweb.casNumber': 'CAS号',
  'pages.matweb.materialName': '材料名',
  'pages.matweb.keywords': '材料关键字',
  'pages.matweb.meltingPoint': '熔点',
  'pages.matweb.boilingPoint': '沸点',
  'pages.matweb.density': '密度',
  'pages.matweb.specificHeatCapacity': '比热容',
  'pages.matweb.importTime': '数据导入时间',
  'pages.matweb.moreActions': '更多操作',
  'pages.matweb.detail': '详情',
  'pages.matweb.edit': '修正数据',
  'pages.matweb.database': 'MatWeb数据库',
  // Data Upload Add missing
  'pages.dataUpload.add.materialData': '材料数据',
  'pages.dataUpload.add.physicalType': '物性类型',
  'pages.dataUpload.add.pleaseSelectPhysicalTypeFirst': '请先选择物性类型',
  'pages.dataUpload.add.tempUnit': '温度单位',
  'pages.dataUpload.add.docData': '文献数据',
  'pages.dataUpload.add.docPage': '页码',
  'pages.dataUpload.add.pleaseInputDocPage': '请输入页码',
  'pages.dataUpload.add.docYear': '年份',
  'pages.dataUpload.add.docTitle': '文献标题',
  'pages.dataUpload.add.pleaseInputDocTitle': '请输入文献标题',
  'pages.dataUpload.add.docKeyword': '文献关键字',
  'pages.dataUpload.add.pleaseInputDocKeyword': '请输入文献关键字',
  'pages.dataUpload.add.docAbstract': '文献摘要',
  'pages.dataUpload.add.pleaseInputDocAbstract': '请输入文献摘要',
  'pages.dataUpload.add.confirmSubmit': '确定提交',
  // Data Upload Edit Table
  'pages.dataUpload.editTable.index': '序号',
  'pages.dataUpload.editTable.component': '组分',
  'pages.dataUpload.editTable.coefficient': '系数',
  'pages.dataUpload.editTable.experimentDataInfo': '实验数据信息',
  'pages.dataUpload.editTable.system': '体系',
  'pages.dataUpload.editTable.physicalType': '物性类型',
  'pages.dataUpload.editTable.dataSource': '数据来源',
  'pages.dataUpload.editTable.physicalUnit': '物性单位',
  'pages.dataUpload.editTable.tempVerifyValue': '温度验证值',
  'pages.dataUpload.editTable.tempUnit': '温度单位',
  'pages.dataUpload.editTable.detail': '详情',
  'pages.dataUpload.editTable.viewDetail': '查看详情',
  'pages.dataUpload.editTable.experimentDataDetail': '实验数据详情',
  'pages.dataUpload.editTable.cancel': '取消',
  'pages.dataUpload.editTable.save': '保存',
  'pages.dataUpload.editTable.modify': '修改',
  'pages.dataUpload.editTable.confirm': '确定',
  'pages.dataUpload.editTable.pleaseSelectPhysicalUnit': '请选择物性单位',
  'pages.dataUpload.editTable.pleaseSelectTempUnit': '请选择温度单位',
  'pages.dataUpload.editTable.importFileFormat': '导入文件格式',
  'pages.dataUpload.editTable.standardExcelFormat': '标准格式Excel',
  'pages.dataUpload.editTable.pageNumber': '页码',
  'pages.dataUpload.editTable.docYear': '文献年份',
  'pages.dataUpload.editTable.docTitle': '文献标题',
  'pages.dataUpload.editTable.docKeyword': '文献关键字',
  'pages.dataUpload.editTable.docAbstract': '文献摘要',
  'pages.dataUpload.editTable.importFile': '导入文件',
  'pages.dataUpload.editTable.pleaseInputCoefficient': '请输入系数',
  'pages.dataUpload.editTable.measuredValue': '实测值',
  'pages.dataUpload.editTable.temperature': '温度',
  'pages.dataUpload.editTable.unitConversion': '单位转换',
  'pages.dataUpload.editTable.convert': '转换',
  // Data Import Edit Table
  'pages.dataImport.editTable.index': '序号',
  'pages.dataImport.editTable.component': '组分',
  'pages.dataImport.editTable.coefficient': '系数',
  'pages.dataImport.editTable.experimentDataInfo': '实验数据信息',
  'pages.dataImport.editTable.system': '体系',
  'pages.dataImport.editTable.physicalType': '物性类型',
  'pages.dataImport.editTable.dataSource': '数据来源',
  'pages.dataImport.editTable.physicalUnit': '物性单位',
  'pages.dataImport.editTable.tempVerifyValue': '温度验证值',
  'pages.dataImport.editTable.tempUnit': '温度单位',
  'pages.dataImport.editTable.detail': '详情',
  'pages.dataImport.editTable.viewDetail': '查看详情',
  'pages.dataImport.editTable.simulationDataDetail': '仿真数据详情',
  'pages.dataImport.editTable.cancel': '取消',
  'pages.dataImport.editTable.save': '保存',
  'pages.dataImport.editTable.modify': '修改',
  'pages.dataImport.editTable.confirm': '确定',
  'pages.dataImport.editTable.pleaseSelectPhysicalUnit': '请选择物性单位',
  'pages.dataImport.editTable.pleaseSelectTempUnit': '请选择温度单位',
  'pages.dataImport.editTable.importFileFormat': '导入文件格式',
  'pages.dataImport.editTable.standardExcelFormat': '标准格式Excel',
  'pages.dataImport.editTable.importFile': '导入文件',
  'pages.dataImport.editTable.measuredValue': '实测值',
  'pages.dataImport.editTable.temperature': '温度',
  // Monitor System Overview
  'pages.monitor.systemOverview.title': '系统概览',
  'pages.monitor.systemOverview.totalServices': '总服务数',
  'pages.monitor.systemOverview.runningServices': '运行中',
  'pages.monitor.systemOverview.memoryUsage': '内存使用',
  'pages.monitor.systemOverview.cpuUsage': 'CPU使用',
  'pages.monitor.systemOverview.diskUsage': '磁盘使用',
  'pages.monitor.systemOverview.noChange': '无变化',
  'pages.monitor.systemOverview.cpuUsageRate': 'CPU 使用率',
  'pages.monitor.systemOverview.memoryUsageRate': '内存使用率',
  'pages.monitor.systemOverview.diskUsageRate': '磁盘使用率',
  'pages.monitor.systemOverview.noData': '暂无数据',
  'pages.monitor.systemOverview.microserviceStatus': '服务状态',
  'pages.monitor.systemOverview.unknownService': '未知服务',
  'pages.monitor.systemOverview.running': '运行中',
  'pages.monitor.systemOverview.stopped': '已停止',
  'pages.monitor.systemOverview.error': '异常',
  'pages.monitor.systemOverview.unknown': '未知',
  'pages.monitor.systemOverview.port': '端口',
  'pages.monitor.systemOverview.responseTime': '响应时间',
  'pages.monitor.systemOverview.activeCount': '活跃数',
  'pages.monitor.systemOverview.metricValue': '指标值',
  'pages.monitor.systemOverview.noServiceData': '暂无服务数据',
  'pages.monitor.systemOverview.fetchFailed': '获取系统概览失败',
  'pages.monitor.systemOverview.fetchFailedRetry': '获取系统概览失败，请稍后重试',
  'pages.monitor.systemOverview.cpuUsageRateTooltip': 'CPU使用率',
  'pages.monitor.systemOverview.memoryUsageRateTooltip': '内存使用率',
  'pages.monitor.systemOverview.diskUsageRateTooltip': '磁盘使用率',
  // Monitor Log Management
  'pages.monitor.logManagement.title': '日志管理',
  'pages.monitor.logManagement.selectMicroservice': '选择微服务',
  'pages.monitor.logManagement.refresh': '刷新',
  'pages.monitor.logManagement.clear': '清空',
  'pages.monitor.logManagement.noAvailableServices': '暂无可用服务',
  'pages.monitor.logManagement.realtimeLogs': '实时日志',
  'pages.monitor.logManagement.historyLogs': '历史日志',
  'pages.monitor.logManagement.noLogData': '暂无日志数据',
  'pages.monitor.logManagement.download': '下载',
  'pages.monitor.logManagement.modifiedTime': '修改时间',
  'pages.monitor.logManagement.total': '共',
  'pages.monitor.logManagement.items': '条',
  'pages.monitor.logManagement.noHistoryLogFiles': '暂无历史日志文件',
  'pages.monitor.logManagement.selectServiceFirst': '请先选择一个服务',
  'pages.monitor.logManagement.fetchServicesFailed': '获取服务列表失败',
  'pages.monitor.logManagement.fetchServicesFailedRetry': '获取服务列表失败，请稍后重试',
  'pages.monitor.logManagement.fetchRealtimeLogsFailed': '获取实时日志失败',
  'pages.monitor.logManagement.fetchRealtimeLogsFailedRetry': '获取实时日志失败，请稍后重试',
  'pages.monitor.logManagement.fetchHistoryLogsFailed': '获取历史日志失败',
  'pages.monitor.logManagement.fetchHistoryLogsFailedRetry': '获取历史日志失败，请稍后重试',
  'pages.monitor.logManagement.downloadStarted': '开始下载日志文件',
  'pages.monitor.logManagement.downloadFailed': '下载日志文件失败',
  'pages.monitor.logManagement.downloadFailedRetry': '下载日志文件失败，请稍后重试',
  'pages.monitor.logManagement.logsCleared': '已清空日志',
}
